import { PLATFORM_ADMIN_ROLE_NAMES as e } from "@teletienda/shared-utils-lib";
import { create as t } from "zustand";
import { createJSONStorage as n, persist as r } from "zustand/middleware";
import i, { HTTPError as a } from "ky";
import { createContext as o, useCallback as s, useContext as c, useEffect as l, useMemo as u, useRef as d, useState as f } from "react";
import { Alert as p, Anchor as m, Avatar as h, Box as g, Button as _, Center as v, Checkbox as y, Divider as b, Group as x, Loader as S, Menu as C, Modal as w, Paper as T, PasswordInput as E, Progress as D, SegmentedControl as O, Stack as k, Text as A, TextInput as j, ThemeIcon as ee, Title as te, UnstyledButton as M, useComputedColorScheme as N, useMantineTheme as ne } from "@mantine/core";
import { useForm as re } from "@mantine/form";
import { IconAlertCircle as ie, IconArrowLeft as ae, IconBrandFacebook as oe, IconBrandGoogle as se, IconCheck as ce, IconChevronDown as le, IconHome as ue, IconInfoCircle as de, IconLock as fe, IconLogout as pe, IconMail as me, IconShieldCheck as he, IconShoppingCart as ge, IconUser as _e, IconWallet as ve, IconX as ye } from "@tabler/icons-react";
import { z as P } from "zod";
import { useTranslation as F } from "react-i18next";
import { Fragment as I, jsx as L, jsxs as R } from "react/jsx-runtime";
import { useDisclosure as be, useMediaQuery as xe } from "@mantine/hooks";
import { notifications as Se } from "@mantine/notifications";
//#region src/utils/storage/config.ts
var Ce = "teletienda-auth", we = "teletienda-auth-sync", Te = "tt-auth-sync", Ee = 2e3, De = 720 * 60 * 60, Oe = ".teletienda.ar", ke = null;
function Ae() {
	return typeof window > "u" ? !1 : window.location.hostname.endsWith(".teletienda.ar");
}
function je() {
	if (typeof window > "u") return "localhost";
	let e = window.location.hostname;
	return e.endsWith(".teletienda.ar") ? Oe : e.endsWith(".teletienda.local") ? ".teletienda.local" : e;
}
function Me() {
	let e = Ae() || typeof window < "u" && window.location.protocol === "https:";
	return {
		cookieDomain: je(),
		secure: e,
		sameSite: "lax",
		maxAge: De,
		storageKey: Ce
	};
}
function z() {
	return ke ||= Me(), ke;
}
function Ne(e) {
	ke = {
		...Me(),
		...e
	};
}
function Pe() {
	ke = null;
}
//#endregion
//#region src/utils/storage/cookies.ts
function Fe() {
	let e = /* @__PURE__ */ new Map();
	if (typeof document > "u") return e;
	let t = document.cookie.split(";");
	for (let n of t) {
		let [t, ...r] = n.split("=");
		if (t) {
			let n = t.trim(), i = r.join("=").trim();
			if (n) try {
				e.set(n, decodeURIComponent(i));
			} catch {
				e.set(n, i);
			}
		}
	}
	return e;
}
function Ie(e) {
	return Fe().get(e) ?? null;
}
function Le(e, t, n) {
	if (typeof document > "u") return;
	let r = z(), i = {
		domain: n?.domain ?? r.cookieDomain,
		path: n?.path ?? "/",
		maxAge: n?.maxAge ?? r.maxAge,
		secure: n?.secure ?? r.secure,
		sameSite: n?.sameSite ?? r.sameSite
	}, a = [
		`${encodeURIComponent(e)}=${encodeURIComponent(t)}`,
		`path=${i.path}`,
		`max-age=${i.maxAge}`,
		`samesite=${i.sameSite}`
	];
	i.domain && i.domain !== "localhost" && a.push(`domain=${i.domain}`), i.secure && a.push("secure"), document.cookie = a.join("; ");
}
function Re(e, t) {
	if (typeof document > "u") return;
	let n = z(), r = t ?? n.cookieDomain, i = [
		`${encodeURIComponent(e)}=`,
		"path=/",
		"max-age=0",
		"expires=Thu, 01 Jan 1970 00:00:00 GMT"
	];
	r && r !== "localhost" && i.push(`domain=${r}`), document.cookie = i.join("; ");
}
function ze() {
	if (typeof document > "u") return !1;
	try {
		let e = "__tt_cookie_test__";
		document.cookie = `${e}=1; path=/`;
		let t = document.cookie.includes(e);
		return document.cookie = `${e}=; path=/; max-age=0`, t;
	} catch {
		return !1;
	}
}
function Be(e, t, n) {
	Le(e, JSON.stringify(t), n);
}
function Ve(e) {
	let t = Ie(e);
	if (!t) return null;
	try {
		return JSON.parse(t);
	} catch {
		return null;
	}
}
//#endregion
//#region src/utils/storage/crossTabSync.ts
var He = class {
	channel = null;
	handlers = /* @__PURE__ */ new Set();
	useFallback = !1;
	boundStorageHandler = null;
	constructor() {
		this.init();
	}
	init() {
		if (!(typeof window > "u")) {
			if ("BroadcastChannel" in window) try {
				this.channel = new BroadcastChannel(we), this.channel.onmessage = (e) => {
					this.notifyHandlers(e.data);
				};
				return;
			} catch {}
			this.useFallback = !0, this.boundStorageHandler = this.handleStorageEvent.bind(this), window.addEventListener("storage", this.boundStorageHandler);
		}
	}
	handleStorageEvent(e) {
		if (e.key === "teletienda-auth-sync" && e.newValue) try {
			let t = JSON.parse(e.newValue);
			this.notifyHandlers(t);
		} catch {}
	}
	notifyHandlers(e) {
		for (let t of this.handlers) try {
			t(e);
		} catch (e) {
			console.error("[shared-auth-ui] Sync handler error:", e);
		}
	}
	subscribe(e) {
		return this.handlers.add(e), () => {
			this.handlers.delete(e);
		};
	}
	broadcast(e, t) {
		let n = {
			type: e,
			timestamp: Date.now(),
			data: t
		};
		if (this.channel) this.channel.postMessage(n);
		else if (this.useFallback && typeof localStorage < "u") try {
			localStorage.setItem(`${Ce}-sync`, JSON.stringify(n)), localStorage.removeItem(`${Ce}-sync`);
		} catch {}
	}
	broadcastLogin() {
		this.broadcast("login");
	}
	broadcastLogout() {
		this.broadcast("logout");
	}
	broadcastTokenRefresh() {
		this.broadcast("token_refresh");
	}
	destroy() {
		this.channel &&= (this.channel.close(), null), this.boundStorageHandler && typeof window < "u" && (window.removeEventListener("storage", this.boundStorageHandler), this.boundStorageHandler = null), this.handlers.clear();
	}
	isUsingBroadcastChannel() {
		return this.channel !== null;
	}
}, Ue = null;
function We() {
	return Ue ||= new He(), Ue;
}
function Ge() {
	Ue &&= (Ue.destroy(), null);
}
function Ke(e) {
	return We().subscribe(e);
}
function qe() {
	We().broadcastLogin();
}
function Je() {
	We().broadcastLogout();
}
function Ye() {
	We().broadcastTokenRefresh();
}
//#endregion
//#region src/utils/storage/crossSubdomainSync.ts
var Xe = class {
	handlers = /* @__PURE__ */ new Set();
	pollInterval = null;
	lastSeenTimestamp = 0;
	currentOrigin = "";
	constructor() {
		typeof window < "u" && (this.currentOrigin = window.location.origin, this.initializeFromCookie());
	}
	initializeFromCookie() {}
	getPendingEvent() {
		let e = Ie(Te);
		if (!e) return null;
		try {
			let t = JSON.parse(e);
			return t.origin === this.currentOrigin || t.timestamp <= this.lastSeenTimestamp ? null : t;
		} catch {
			return null;
		}
	}
	startPolling() {
		this.pollInterval || typeof window > "u" || (this.pollInterval = setInterval(() => {
			this.checkForChanges();
		}, Ee));
	}
	stopPolling() {
		this.pollInterval &&= (clearInterval(this.pollInterval), null);
	}
	checkForChanges() {
		let e = Ie(Te);
		if (e) try {
			let t = JSON.parse(e);
			if (t.origin === this.currentOrigin || t.timestamp <= this.lastSeenTimestamp) return;
			this.lastSeenTimestamp = t.timestamp;
			let n = {
				type: t.type,
				timestamp: t.timestamp
			};
			this.notifyHandlers(n);
		} catch {}
	}
	notifyHandlers(e) {
		for (let t of this.handlers) try {
			t(e);
		} catch (e) {
			console.error("[shared-auth-ui] Cross-subdomain sync handler error:", e);
		}
	}
	subscribe(e) {
		if (this.handlers.add(e), this.handlers.size === 1) {
			this.startPolling();
			let t = this.getPendingEvent();
			t && (this.lastSeenTimestamp = t.timestamp, setTimeout(() => {
				e({
					type: t.type,
					timestamp: t.timestamp
				});
			}, 0));
		}
		return () => {
			this.handlers.delete(e), this.handlers.size === 0 && this.stopPolling();
		};
	}
	broadcast(e) {
		if (typeof window > "u") return;
		let t = {
			type: e,
			timestamp: Date.now(),
			origin: this.currentOrigin
		};
		this.lastSeenTimestamp = t.timestamp, Le(Te, JSON.stringify(t), { maxAge: 300 });
	}
	broadcastLogin() {
		this.broadcast("login");
	}
	broadcastLogout() {
		this.broadcast("logout");
	}
	broadcastTokenRefresh() {
		this.broadcast("token_refresh");
	}
	destroy() {
		this.stopPolling(), this.handlers.clear();
	}
	isPolling() {
		return this.pollInterval !== null;
	}
}, Ze = null;
function Qe() {
	return Ze ||= new Xe(), Ze;
}
function $e() {
	Ze &&= (Ze.destroy(), null);
}
function et(e) {
	return Qe().subscribe(e);
}
function tt() {
	Qe().broadcastLogin();
}
function nt() {
	Qe().broadcastLogout();
}
function rt() {
	Qe().broadcastTokenRefresh();
}
//#endregion
//#region src/utils/storage/slimCookieStorage.ts
var it = "tt-auth-slim", at = 3072, ot = 4096;
function st(e) {
	if (!e || typeof e != "object") return !1;
	let t = e;
	return typeof t.token == "string" && typeof t.refreshToken == "string" && typeof t.userGuid == "string" && typeof t.isAuthenticated == "boolean" && typeof t.expiresAt == "number";
}
function ct(e) {
	return typeof Blob < "u" ? new Blob([e]).size : new TextEncoder().encode(e).length;
}
function lt() {
	let e = Ie(it), t = e ? ct(e) : 0;
	return {
		currentSize: t,
		maxSize: ot,
		warningThreshold: at,
		isOverWarning: t > at,
		isOverLimit: t > ot,
		percentUsed: Math.round(t / ot * 100)
	};
}
function ut(e) {
	let t = JSON.stringify(e), n = ct(t);
	return n > 4096 ? (console.error(`[SlimCookie] Cookie size (${n} bytes) exceeds maximum (${ot} bytes). Cookie will NOT be set to prevent silent browser rejection.`), !1) : (n > 3072 && console.warn(`[SlimCookie] Cookie size (${n} bytes) exceeds warning threshold (${at} bytes). Consider reducing stored data.`), Le(it, t), !0);
}
function B() {
	let e = Ie(it);
	if (!e) return null;
	try {
		let t = JSON.parse(e);
		return st(t) ? t : (console.warn("[SlimCookie] Cookie contains invalid SlimAuthData structure"), null);
	} catch (e) {
		return console.warn("[SlimCookie] Failed to parse cookie JSON:", e), null;
	}
}
function V() {
	Re(it);
}
//#endregion
//#region src/api/config.ts
var H = { timeout: 3e4 }, dt = null;
function ft(e) {
	return e && e.length > 0 ? e : (console.error("[shared-auth-ui] baseUrl is not declared: pass apiBaseUrl / configureAuthApi({baseUrl}). Falling back to \"/\" — on a merchant app this is the WRONG service."), "/");
}
function pt(e) {
	H = {
		...H,
		...e
	}, dt = i.create({
		prefixUrl: ft(H.baseUrl),
		timeout: H.timeout,
		hooks: { beforeRequest: [(e) => {
			if (H.getToken) {
				let t = H.getToken();
				t && e.headers.set("Authorization", `Bearer ${t}`);
			}
		}] }
	});
}
function U() {
	return dt ||= i.create({
		prefixUrl: ft(H.baseUrl),
		timeout: H.timeout,
		hooks: { beforeRequest: [(e) => {
			if (H.getToken) {
				let t = H.getToken();
				t && e.headers.set("Authorization", `Bearer ${t}`);
			}
		}] }
	}), dt;
}
function mt() {
	return { ...H };
}
function ht(e) {
	H.getToken = e;
}
//#endregion
//#region src/utils/transformApiUser.ts
function W(e) {
	return {
		userGuid: e.user_guid,
		email: e.email || e.notification_email || e.notificationEmail,
		name: e.display_name || e.first_name || e.email?.split("@")[0] || "",
		firstName: e.first_name,
		lastName: e.last_name,
		phone: e.phone,
		avatarUrl: e.avatar || e.avatar_url,
		roles: e.roles || [],
		permissions: e.permissions || [],
		merchantGuid: e.merchant_guid,
		merchantGuids: e.merchant_guids,
		preferred_currency: e.preferred_currency,
		languageCode: e.language_code
	};
}
//#endregion
//#region src/utils/storage/authStorage.ts
function gt() {
	let e = {
		localStorage: !1,
		cookies: !1,
		broadcastChannel: !1,
		slimCookieSize: 0,
		slimCookieHealthy: !0
	};
	if (typeof window < "u" && window.localStorage) try {
		let t = "__tt_storage_test__";
		localStorage.setItem(t, "1"), localStorage.removeItem(t), e.localStorage = !0;
	} catch {}
	e.cookies = ze(), typeof window < "u" && "BroadcastChannel" in window && (e.broadcastChannel = !0);
	let t = lt();
	return e.slimCookieSize = t.currentSize, e.slimCookieHealthy = !t.isOverWarning, e;
}
function _t() {
	if (typeof window > "u") return !1;
	try {
		let e = "__tt_private_test__";
		return localStorage.setItem(e, "1"), localStorage.removeItem(e), "storage" in navigator && "estimate" in navigator.storage, !1;
	} catch {
		return !0;
	}
}
function vt(e) {
	let t = z();
	return e === t.storageKey || e.startsWith(t.storageKey) ? e : `${t.storageKey}-${e}`;
}
async function yt(e) {
	try {
		let t = await U().get("api/v1/users/me", { headers: { Authorization: `Bearer ${e}` } }).json();
		return t.success && t.data ? {
			status: "ok",
			user: W(t.data)
		} : (console.warn("[AuthStorage] hydrateFromApi: Invalid response format"), { status: "error" });
	} catch (e) {
		return e instanceof Error && e.message.includes("401") ? { status: "unauthorized" } : (console.warn("[AuthStorage] hydrateFromApi failed:", e), { status: "error" });
	}
}
function bt(e) {
	if (!e || typeof e != "object") return !1;
	let t = e.user;
	return t ? Array.isArray(t.roles) && Array.isArray(t.permissions) && typeof t.email == "string" : !1;
}
function xt() {
	let e = vt(z().storageKey);
	if (typeof window < "u" && window.localStorage) try {
		let t = localStorage.getItem(e);
		if (t && bt(JSON.parse(t)?.state)) return !1;
	} catch {}
	let t = B();
	return t !== null && t.isAuthenticated;
}
var St = class {
	cookiesAvailable;
	localStorageAvailable;
	constructor() {
		let e = gt();
		this.cookiesAvailable = e.cookies, this.localStorageAvailable = e.localStorage, !this.localStorageAvailable && !this.cookiesAvailable ? console.warn("[shared-auth-ui] No storage available. Auth state will not persist.") : this.cookiesAvailable || console.warn("[shared-auth-ui] Cookies disabled. Cross-subdomain SSO will not work.");
	}
	getItem(e) {
		let t = vt(e), n = null;
		if (this.localStorageAvailable) try {
			n = localStorage.getItem(t);
		} catch {}
		if (n !== null) try {
			if (JSON.parse(n)?.state?.isAuthenticated === !0) return n;
		} catch {}
		if (this.cookiesAvailable) {
			let e = B();
			if (e && e.isAuthenticated) try {
				if ((n ? JSON.parse(n) : null)?.state?.isAuthenticated !== !0) {
					let t = {
						state: {
							user: { userGuid: e.userGuid },
							token: e.token,
							refreshToken: e.refreshToken,
							expiresAt: e.expiresAt,
							isAuthenticated: !0,
							isLoading: !1,
							_needsHydration: !0
						},
						version: 0
					};
					return JSON.stringify(t);
				}
			} catch {
				let t = {
					state: {
						user: { userGuid: e.userGuid },
						token: e.token,
						refreshToken: e.refreshToken,
						expiresAt: e.expiresAt,
						isAuthenticated: !0,
						isLoading: !1,
						_needsHydration: !0
					},
					version: 0
				};
				return JSON.stringify(t);
			}
			else if (e && !e.isAuthenticated && n) try {
				if (JSON.parse(n)?.state?.isAuthenticated === !0) {
					let e = {
						state: {
							user: null,
							token: null,
							refreshToken: null,
							expiresAt: null,
							isAuthenticated: !1,
							isLoading: !1
						},
						version: 0
					};
					if (this.localStorageAvailable) try {
						localStorage.setItem(t, JSON.stringify(e));
					} catch {}
					return JSON.stringify(e);
				}
			} catch {}
		}
		return n === null ? null : n;
	}
	setItem(e, t) {
		let n = vt(e);
		if (this.localStorageAvailable) try {
			localStorage.setItem(n, t);
		} catch (e) {
			if (this.isQuotaExceededError(e)) {
				this.handleQuotaExceeded();
				try {
					localStorage.setItem(n, t);
				} catch {}
			}
		}
		if (this.cookiesAvailable) try {
			let e = JSON.parse(t)?.state, n = e?.user?.userGuid;
			if (e?.token && n) {
				if (!e.expiresAt) return;
				ut({
					token: e.token,
					refreshToken: e.refreshToken || "",
					userGuid: n,
					isAuthenticated: e.isAuthenticated ?? !0,
					expiresAt: e.expiresAt
				});
			} else e?.isAuthenticated || V();
		} catch {}
	}
	removeItem(e) {
		let t = vt(e);
		if (this.localStorageAvailable) try {
			localStorage.removeItem(t);
		} catch {}
		this.cookiesAvailable && (Re(t), V());
	}
	clear() {
		let e = z();
		if (this.localStorageAvailable) try {
			let t = [];
			for (let n = 0; n < localStorage.length; n++) {
				let r = localStorage.key(n);
				r && r.startsWith(e.storageKey) && t.push(r);
			}
			t.forEach((e) => localStorage.removeItem(e));
		} catch {}
		this.cookiesAvailable && (Re(e.storageKey), Re(`${e.storageKey}-sync`), V()), Je();
	}
	isQuotaExceededError(e) {
		return e instanceof DOMException && (e.code === 22 || e.code === 1014 || e.name === "QuotaExceededError" || e.name === "NS_ERROR_DOM_QUOTA_REACHED");
	}
	handleQuotaExceeded() {
		console.warn("[shared-auth-ui] Storage quota exceeded. Clearing old data.");
		let e = z();
		try {
			let t = [];
			for (let n = 0; n < localStorage.length; n++) {
				let r = localStorage.key(n);
				r && r.startsWith(e.storageKey) && r !== e.storageKey && t.push(r);
			}
			t.forEach((e) => localStorage.removeItem(e));
		} catch {}
	}
	getHealth() {
		let e = lt();
		return {
			localStorage: this.localStorageAvailable,
			cookies: this.cookiesAvailable,
			broadcastChannel: typeof window < "u" && "BroadcastChannel" in window,
			slimCookieSize: e.currentSize,
			slimCookieHealthy: !e.isOverWarning
		};
	}
	notifyLogin() {
		qe(), tt();
	}
	notifyLogout() {
		Je(), nt();
	}
	notifyTokenRefresh() {
		Ye(), rt();
	}
}, Ct = null;
function G() {
	return Ct ||= new St(), Ct;
}
function wt() {
	Ct = null;
}
function Tt() {
	return G();
}
//#endregion
//#region src/store/authStore.ts
var Et = Ce, K = {
	user: null,
	token: null,
	refreshToken: null,
	expiresAt: null,
	isAuthenticated: !1,
	isLoading: !1
}, Dt = null;
function Ot(e) {
	Dt = e;
}
function kt() {
	return Dt || Tt();
}
var At = (t, n) => ({
	...K,
	login: (e, n, r, i) => {
		t({
			token: e,
			refreshToken: n,
			expiresAt: Date.now() + r * 1e3,
			user: i,
			isAuthenticated: !0,
			isLoading: !1
		}), G().notifyLogin();
	},
	logout: () => {
		t(K), G().notifyLogout();
	},
	updateToken: (e, n, r) => {
		t({
			token: e,
			expiresAt: Date.now() + n * 1e3,
			...r && { refreshToken: r }
		}), G().notifyTokenRefresh();
	},
	updateUser: (e) => {
		t({ user: e });
	},
	setLoading: (e) => {
		t({ isLoading: e });
	},
	hasRole: (e) => {
		let { user: t } = n();
		return t ? t.roles.includes(e) : !1;
	},
	hasAnyRole: (e) => {
		let { user: t } = n();
		return t ? e.some((e) => t.roles.includes(e)) : !1;
	},
	hasPermission: (t) => {
		let { user: r } = n();
		return r ? e.some((e) => r.roles.includes(e)) ? !0 : r.permissions.includes(t) : !1;
	}
}), jt = {
	name: Et,
	storage: n(() => kt()),
	partialize: (e) => ({
		user: e.user,
		token: e.token,
		refreshToken: e.refreshToken,
		expiresAt: e.expiresAt,
		isAuthenticated: e.isAuthenticated
	})
}, q = t()(r(At, jt)), Mt = !1;
async function Nt(e, t = 3, n = !1) {
	for (let r = 0; r < t; r++) {
		if (await q.persist.rehydrate(), q.getState().isAuthenticated === e) return;
		!n && r < t - 1 && await new Promise((e) => setTimeout(e, 500 * 2 ** r));
	}
	console.warn("[shared-auth-ui] Rehydrate retry exhausted, state may be stale");
}
function Pt() {
	let e = B();
	if (!e?.isAuthenticated || !e?.token) return !1;
	let t = q.getState();
	return t.user?.userGuid && e.userGuid && t.user.userGuid !== e.userGuid ? (console.debug("[shared-auth-ui] UserGuid mismatch - forcing hydration"), !0) : !(t.isAuthenticated && t.user && Array.isArray(t.user.roles) && t.user.roles.length > 0);
}
async function Ft() {
	let e = B();
	if (!e?.token || !e?.isAuthenticated) return;
	let t = q.getState(), n = !t.user?.userGuid || t.user.userGuid === e.userGuid;
	if (!(t.isAuthenticated && t.user?.roles?.length && n)) {
		console.debug(n ? "[shared-auth-ui] Performing initial hydration from slim cookie" : "[shared-auth-ui] Performing initial hydration - userGuid mismatch detected"), q.setState({
			token: e.token,
			refreshToken: e.refreshToken,
			expiresAt: e.expiresAt,
			isAuthenticated: !0,
			isLoading: !0,
			user: null
		});
		try {
			let t = await yt(e.token);
			t.status === "ok" ? (q.setState({
				user: t.user,
				isLoading: !1
			}), console.debug("[shared-auth-ui] Initial hydration successful")) : t.status === "unauthorized" ? (q.setState(K), V(), console.debug("[shared-auth-ui] Initial hydration failed - token rejected (401)")) : (q.setState(K), console.debug("[shared-auth-ui] Initial hydration deferred - transient error, slim cookie preserved"));
		} catch (e) {
			console.warn("[shared-auth-ui] Initial hydration error:", e), q.setState(K);
		}
	}
}
async function It() {
	Pt() && await Ft();
}
function Lt() {
	if (Mt) return console.debug("[shared-auth-ui] Sync already initialized"), () => {};
	Mt = !0, Pt() && Ft();
	let e = async (e) => {
		let t = q.getState();
		switch (e.type) {
			case "logout":
				t.isAuthenticated && q.setState(K), V(), setTimeout(() => Nt(!1), 500);
				break;
			case "login": {
				let e = B();
				if (!e?.token || !e?.isAuthenticated) {
					console.debug("[shared-auth-ui] Cross-subdomain login: no slim cookie, retrying"), setTimeout(() => Nt(!0), 500);
					return;
				}
				console.debug("[shared-auth-ui] Cross-subdomain login: validating token before state update"), q.setState({ isLoading: !0 });
				try {
					let t = await yt(e.token);
					t.status === "ok" ? (console.debug("[shared-auth-ui] Cross-subdomain login: token validated, updating state"), q.setState({
						token: e.token,
						refreshToken: e.refreshToken,
						expiresAt: e.expiresAt,
						isAuthenticated: !0,
						isLoading: !1,
						user: t.user
					})) : t.status === "unauthorized" ? (console.warn("[shared-auth-ui] Cross-subdomain login: token rejected (401), clearing state"), q.setState(K), V()) : (console.warn("[shared-auth-ui] Cross-subdomain login: transient error, slim cookie preserved"), q.setState({ isLoading: !1 }));
				} catch (e) {
					console.warn("[shared-auth-ui] Cross-subdomain login: API error", e), q.setState({ isLoading: !1 });
				}
				break;
			}
			case "token_refresh": {
				let e = B();
				e?.token && q.setState({
					token: e.token,
					expiresAt: e.expiresAt
				}), setTimeout(() => q.persist.rehydrate(), 500);
				break;
			}
		}
	}, t = Ke(e), n = et(e);
	return () => {
		Mt = !1, t(), n();
	};
}
function Rt() {
	let { expiresAt: e } = q.getState();
	return e ? Date.now() >= e - 120 * 1e3 : !1;
}
function zt() {
	let { expiresAt: e } = q.getState();
	return e ? Date.now() >= e : !0;
}
function J() {
	G().clear();
}
function Bt() {
	return G().getHealth();
}
//#endregion
//#region src/api/authApi.ts
var Y = class extends Error {
	code;
	status;
	details;
	constructor(e, t, n, r) {
		super(e), this.name = "AuthApiError", this.code = t, this.status = n, this.details = r;
	}
};
async function Vt(e) {
	if (e instanceof a) try {
		let t = await e.response.json();
		throw new Y(t.error?.message || e.message, t.error?.code || "HTTP_ERROR", e.response.status, t.error?.details);
	} catch (t) {
		throw t instanceof Y ? t : new Y(e.message, "HTTP_ERROR", e.response.status);
	}
	throw e instanceof Error ? new Y(e.message, "NETWORK_ERROR", 0) : new Y("Unknown error", "UNKNOWN_ERROR", 0);
}
async function Ht(e) {
	let t = U();
	try {
		let n = await t.post("api/v1/auth/login", { json: e }).json();
		if (!n.success || !n.data) throw new Y(n.error?.message || "Login failed", n.error?.code || "LOGIN_FAILED", 400, n.error?.details);
		return n.data;
	} catch (e) {
		if (e instanceof Y) throw e;
		return Vt(e);
	}
}
async function Ut(e) {
	let t = U();
	try {
		let n = await t.post("api/v1/auth/register", { json: e }).json();
		if (!n.success || !n.data) throw new Y(n.error?.message || "Registration failed", n.error?.code || "REGISTRATION_FAILED", 400, n.error?.details);
		return n.data;
	} catch (e) {
		if (e instanceof Y) throw e;
		return Vt(e);
	}
}
async function Wt(e) {
	let t = U();
	try {
		let n = { refreshToken: e }, r = await t.post("api/v1/auth/refresh-token", { json: n }).json();
		if (!r.success || !r.data) throw new Y(r.error?.message || "Token refresh failed", r.error?.code || "REFRESH_FAILED", 400, r.error?.details);
		return r.data;
	} catch (e) {
		if (e instanceof Y) throw e;
		return Vt(e);
	}
}
async function Gt(e) {
	let t = U();
	try {
		let n = { refreshToken: e };
		await t.post("api/v1/auth/logout", {
			json: n,
			timeout: 5e3
		});
	} catch {}
}
async function Kt(e) {
	let t = U();
	try {
		let n = await t.post("api/v1/auth/request-login-code", { json: { email: e } }).json();
		if (!n.success || !n.data) throw new Y(n.error?.message || "Failed to request login code", n.error?.code || "REQUEST_CODE_FAILED", 400, n.error?.details);
		return n.data;
	} catch (e) {
		if (e instanceof Y) throw e;
		return Vt(e);
	}
}
async function qt(e, t) {
	let n = U();
	try {
		let r = await n.post("api/v1/auth/login-by-code", { json: {
			email: e,
			code: t
		} }).json();
		if (!r.success || !r.data) throw new Y(r.error?.message || "Login by code failed", r.error?.code || "LOGIN_BY_CODE_FAILED", 400, r.error?.details);
		return r.data;
	} catch (e) {
		if (e instanceof Y) throw e;
		return Vt(e);
	}
}
async function X(e) {
	let t = U();
	try {
		let n = await t.get("api/v1/users/me", {
			headers: { Authorization: `Bearer ${e}` },
			timeout: 1e4
		}).json();
		if (!n.success || !n.data) throw new Y(n.error?.message || "Failed to fetch user profile", n.error?.code || "PROFILE_FETCH_FAILED", 400, n.error?.details);
		return n.data;
	} catch (e) {
		if (e instanceof Y) throw e;
		return Vt(e);
	}
}
//#endregion
//#region src/api/oauthApi.ts
async function Jt(e) {
	let t = U();
	try {
		let n = await t.post("api/v1/oauth/google/callback", { json: e }).json();
		if (!n.success || !n.data) throw new Y(n.error?.message || "Google OAuth failed", n.error?.code || "GOOGLE_OAUTH_FAILED", 400, n.error?.details);
		return n.data;
	} catch (e) {
		if (e instanceof Y) throw e;
		return Z(e, "Google");
	}
}
async function Yt(e) {
	let t = U();
	try {
		let n = await t.post("api/v1/oauth/google/oidc/start", { json: e ? { returnUrl: e } : {} }).json();
		if (!n.success || !n.data) throw new Y(n.error?.message || "Google OIDC start failed", n.error?.code || "GOOGLE_OIDC_START_FAILED", 400, n.error?.details);
		return n.data;
	} catch (e) {
		if (e instanceof Y) throw e;
		return Z(e, "Google");
	}
}
async function Xt(e) {
	let t = U();
	try {
		let n = await t.post("api/v1/auth/link/google/oidc/start", { json: e ? { returnUrl: e } : {} }).json();
		if (!n.success || !n.data) throw new Y(n.error?.message || "Google OIDC link start failed", n.error?.code || "GOOGLE_OIDC_LINK_START_FAILED", 400, n.error?.details);
		return n.data;
	} catch (e) {
		if (e instanceof Y) throw e;
		return Z(e, "Google");
	}
}
async function Zt(e, t) {
	let n = U();
	try {
		let r = await n.post("api/v1/oauth/google/oidc/callback", { json: {
			code: e,
			state: t
		} }).json();
		if (!r.success || !r.data) throw new Y(r.error?.message || "Google OIDC callback failed", r.error?.code || "GOOGLE_OIDC_CALLBACK_FAILED", 400, r.error?.details);
		return r.data;
	} catch (e) {
		if (e instanceof Y) throw e;
		return Z(e, "Google");
	}
}
async function Qt(e) {
	let t = U();
	try {
		let n = await t.post("api/v1/oauth/facebook/callback", { json: e }).json();
		if (!n.success || !n.data) throw new Y(n.error?.message || "Facebook OAuth failed", n.error?.code || "FACEBOOK_OAUTH_FAILED", 400, n.error?.details);
		return n.data;
	} catch (e) {
		if (e instanceof Y) throw e;
		return Z(e, "Facebook");
	}
}
async function $t(e) {
	let t = U();
	try {
		let n = await t.post("api/v1/oauth/telegram/oidc/start", { json: e ? { returnUrl: e } : {} }).json();
		if (!n.success || !n.data) throw new Y(n.error?.message || "Telegram OIDC start failed", n.error?.code || "TELEGRAM_OIDC_START_FAILED", 400, n.error?.details);
		return n.data;
	} catch (e) {
		if (e instanceof Y) throw e;
		return Z(e, "Telegram");
	}
}
async function en(e, t) {
	let n = U(), r = {};
	e && (r.returnUrl = e), t?.requestBotAccess && (r.requestBotAccess = !0);
	try {
		let e = await n.post("api/v1/auth/link/telegram/oidc/start", { json: r }).json();
		if (!e.success || !e.data) throw new Y(e.error?.message || "Telegram OIDC link start failed", e.error?.code || "TELEGRAM_OIDC_LINK_START_FAILED", 400, e.error?.details);
		return e.data;
	} catch (e) {
		if (e instanceof Y) throw e;
		return Z(e, "Telegram");
	}
}
async function tn(e, t) {
	let n = U();
	try {
		let r = await n.post("api/v1/oauth/telegram/oidc/callback", { json: {
			code: e,
			state: t
		} }).json();
		if (!r.success || !r.data) throw new Y(r.error?.message || "Telegram OIDC callback failed", r.error?.code || "TELEGRAM_OIDC_CALLBACK_FAILED", 400, r.error?.details);
		return r.data;
	} catch (e) {
		if (e instanceof Y) throw e;
		return Z(e, "Telegram");
	}
}
async function Z(e, t) {
	let { HTTPError: n } = await import("ky");
	if (e instanceof n) try {
		let n = await e.response.json();
		throw new Y(n.error?.message || e.message, n.error?.code || `${t.toUpperCase()}_OAUTH_ERROR`, e.response.status, n.error?.details);
	} catch (n) {
		throw n instanceof Y ? n : new Y(e.message, `${t.toUpperCase()}_OAUTH_ERROR`, e.response.status);
	}
	throw e instanceof Error ? new Y(e.message, "NETWORK_ERROR", 0) : new Y("Unknown error", "UNKNOWN_ERROR", 0);
}
//#endregion
//#region src/api/httpClient.ts
var Q = null, nn = [];
function rn() {
	Q = null, nn.length = 0;
}
async function an(e) {
	if (Q) return Q;
	let t = q.getState(), n = t.refreshToken;
	if (!n) throw t.logout(), J(), e?.(), new Y("No refresh token", "NO_REFRESH_TOKEN", 401);
	return Q = (async () => {
		try {
			let e = await Wt(n);
			t.updateToken(e.accessToken, e.expiresIn, e.refreshToken);
			let r = e.accessToken;
			return nn.forEach(({ resolve: e }) => e(r)), nn.length = 0, r;
		} catch (n) {
			throw nn.forEach(({ reject: e }) => e(n)), nn.length = 0, n instanceof Y && (n.status === 401 || n.status === 422) && (t.logout(), J(), e?.()), n;
		} finally {
			Q = null;
		}
	})(), Q;
}
function on() {
	return new Promise((e, t) => {
		nn.push({
			resolve: e,
			reject: t
		});
	});
}
function sn(e = {}) {
	let { baseUrl: t, timeout: n = 3e4, onSessionExpired: r } = e;
	return i.create({
		prefixUrl: t,
		timeout: n,
		hooks: {
			beforeRequest: [async (e) => {
				if (Q) try {
					let t = await on();
					e.headers.set("Authorization", `Bearer ${t}`);
					return;
				} catch {}
				let t = q.getState().token;
				t && e.headers.set("Authorization", `Bearer ${t}`);
			}],
			afterResponse: [async (e, t, n) => {
				if (n.status !== 401 || e.url.includes("/auth/refresh") || e.url.includes("/auth/login")) return n;
				try {
					let n = await an(r), a = {
						...t,
						headers: {
							...Object.fromEntries(e.headers.entries()),
							Authorization: `Bearer ${n}`
						}
					};
					return i(e.url, a);
				} catch {
					return n;
				}
			}]
		}
	});
}
var cn = null, ln = {};
function un(e) {
	ln = e, cn = sn(e);
}
function dn() {
	return cn ||= sn(ln), cn;
}
async function fn(e, t) {
	let n = dn();
	try {
		return await n(e, t).json();
	} catch (e) {
		if (e instanceof a) {
			let t = await e.response.json().catch(() => ({}));
			throw new Y(t.error?.message || e.message, t.error?.code || "HTTP_ERROR", e.response.status, t.error?.details);
		}
		throw e;
	}
}
//#endregion
//#region src/hooks/useAuth.ts
function pn() {
	let e = q((e) => e.user), t = q((e) => e.token), n = q((e) => e.refreshToken), r = q((e) => e.isAuthenticated), i = q((e) => e.isLoading), a = q((e) => e.login), o = q((e) => e.logout), c = q((e) => e.updateToken), l = q((e) => e.updateUser), u = q((e) => e.setLoading), d = q((e) => e.hasRole), f = q((e) => e.hasAnyRole), p = q((e) => e.hasPermission);
	return {
		user: e,
		token: t,
		isAuthenticated: r,
		isLoading: i,
		loginWithCredentials: s(async (e) => {
			u(!0);
			try {
				let { accessToken: t, refreshToken: n, expiresIn: r, user: i } = await Ht(e), o = await X(t), s = W({
					...o,
					user_guid: o.user_guid || i.guid,
					email: o.email || i.email
				});
				return a(t, n, r, s), s;
			} catch (e) {
				throw u(!1), e;
			}
		}, [a, u]),
		loginByCode: s(async (e, t) => {
			u(!0);
			try {
				let { accessToken: n, refreshToken: r, expiresIn: i, user: o } = await qt(e, t), s = await X(n), c = W({
					...s,
					user_guid: s.user_guid || o.guid,
					email: s.email || o.email
				});
				return a(n, r, i, c), c;
			} catch (e) {
				throw u(!1), e;
			}
		}, [a, u]),
		registerUser: s(async (e) => {
			u(!0);
			try {
				let { accessToken: t, refreshToken: n, expiresIn: r, user: i } = await Ut(e), o = await X(t), s = W({
					...o,
					user_guid: o.user_guid || i.guid,
					email: o.email || i.email
				});
				return a(t, n, r, s), s;
			} catch (e) {
				throw u(!1), e;
			}
		}, [a, u]),
		refreshToken: s(async () => {
			if (!n) throw o(), J(), new Y("No refresh token available", "NO_REFRESH_TOKEN", 401);
			try {
				let e = await Wt(n);
				c(e.accessToken, e.expiresIn);
			} catch (e) {
				throw o(), J(), e;
			}
		}, [
			n,
			o,
			c
		]),
		logout: s(async () => {
			n && Gt(n), o(), J();
		}, [n, o]),
		fetchProfile: s(async (e) => {
			if (!t) throw new Y("Not authenticated", "NOT_AUTHENTICATED", 401);
			let n = e?.silent ?? !1;
			n || u(!0);
			try {
				let e = W(await X(t));
				return l(e), n || u(!1), e;
			} catch (e) {
				throw n || u(!1), e;
			}
		}, [
			t,
			u,
			l
		]),
		hasRole: d,
		hasAnyRole: f,
		hasPermission: p
	};
}
//#endregion
//#region src/hooks/useHasHydrated.ts
function mn() {
	let [e, t] = f(() => q.persist?.hasHydrated?.() ?? !1);
	return l(() => {
		if (e) return;
		let n = q.persist?.onFinishHydration?.(() => {
			t(!0);
		});
		return q.persist?.hasHydrated?.() && t(!0), () => {
			n?.();
		};
	}, [e]), e;
}
//#endregion
//#region src/hooks/useAuthGuard.ts
function hn(e = {}) {
	let { requiredRoles: t = [], requiredPermissions: n = [], requireAllRoles: r = !1 } = e, i = mn(), a = q((e) => e.user), o = q((e) => e.isAuthenticated), s = q((e) => e.hasRole), c = q((e) => e.hasPermission), l = !i;
	return {
		...u(() => {
			if (!o || !a) return {
				isAllowed: !1,
				isAuthenticated: !1,
				missingRoles: t,
				missingPermissions: n,
				denyReason: "not_authenticated"
			};
			let e = [], i = !0;
			t.length > 0 && (r ? (e = t.filter((e) => !s(e)), i = e.length === 0) : t.some((e) => s(e)) || (e = t, i = !1));
			let l = n.filter((e) => !c(e)), u = l.length === 0;
			return i ? u ? {
				isAllowed: !0,
				isAuthenticated: !0,
				missingRoles: [],
				missingPermissions: [],
				denyReason: "none"
			} : {
				isAllowed: !1,
				isAuthenticated: !0,
				missingRoles: [],
				missingPermissions: l,
				denyReason: "missing_permissions"
			} : {
				isAllowed: !1,
				isAuthenticated: !0,
				missingRoles: e,
				missingPermissions: l,
				denyReason: "missing_roles"
			};
		}, [
			o,
			a,
			t,
			n,
			r,
			s,
			c
		]),
		isLoading: l,
		user: a
	};
}
//#endregion
//#region src/hooks/useTokenRefresh.ts
var gn = 300 * 1e3, _n = 3, vn = 1e3, $ = null;
function yn() {
	return $;
}
function bn() {
	$ = null;
}
function xn(e = {}) {
	let { refreshThreshold: t = gn, maxRetries: n = _n, retryBaseDelay: r = vn, onRefreshError: i, onSessionExpired: a } = e, [o, c] = f(!1), [u, p] = f(null), [m, h] = f(0), [g, _] = f(null), v = d(null), y = d(null), b = d(!0), x = q((e) => e.refreshToken), S = q((e) => e.expiresAt), C = q((e) => e.isAuthenticated), w = q((e) => e.updateToken), T = q((e) => e.logout), E = s(() => {
		v.current &&= (clearTimeout(v.current), null);
	}, []), D = s(() => {
		y.current &&= (clearInterval(y.current), null);
	}, []), O = s(async (e = 0) => {
		if ($) return $;
		if (!x) throw new Y("No refresh token available", "NO_REFRESH_TOKEN", 401);
		return $ = (async () => {
			try {
				b.current && (c(!0), h(e));
				let t = await Wt(x);
				b.current && (w(t.accessToken, t.expiresIn, t.refreshToken), p(/* @__PURE__ */ new Date()), h(0));
			} catch (t) {
				let o = t instanceof Y ? t : new Y(t instanceof Error ? t.message : "Unknown error", "REFRESH_ERROR", 0);
				if (o.status === 401 || o.status === 422) throw b.current && (T(), J()), a?.(), o;
				if (o.code === "NETWORK_ERROR" && e < n) {
					let t = r * 2 ** e;
					return await new Promise((e) => setTimeout(e, t)), $ = null, O(e + 1);
				}
				throw i?.(o), o;
			} finally {
				$ = null, b.current && c(!1);
			}
		})(), $;
	}, [
		x,
		w,
		T,
		n,
		r,
		i,
		a
	]), k = s(() => {
		if (E(), !S || !C) return;
		let e = Date.now(), n = S - t - e;
		n <= 0 ? O().catch(() => {}) : v.current = setTimeout(() => {
			document.visibilityState === "visible" && O().catch(() => {});
		}, n);
	}, [
		S,
		C,
		t,
		E,
		O
	]), A = s(() => {
		document.visibilityState === "visible" ? S && C && (S - Date.now() <= t ? O().catch(() => {}) : k()) : E();
	}, [
		S,
		C,
		t,
		O,
		k,
		E
	]), j = s(async () => O(0), [O]);
	return l(() => {
		if (D(), !S || !C) {
			_(null);
			return;
		}
		let e = () => {
			let e = S - Date.now();
			_(e > 0 ? e : 0);
		};
		return e(), y.current = setInterval(e, 1e3), () => {
			D();
		};
	}, [
		S,
		C,
		D
	]), l(() => {
		k();
	}, [k]), l(() => (document.addEventListener("visibilitychange", A), () => {
		document.removeEventListener("visibilitychange", A);
	}), [A]), l(() => (b.current = !0, () => {
		b.current = !1, E(), D();
	}), [E, D]), {
		isRefreshing: o,
		lastRefresh: u,
		refresh: j,
		timeUntilExpiry: g,
		retryCount: m
	};
}
//#endregion
//#region src/hooks/useFacebookAuth.ts
function Sn(e) {
	let { appId: t, onSuccess: n, onError: r } = e, i = q((e) => e.login), a = q((e) => e.setLoading), [o, c] = f(!1), [u, p] = f(!1), [m, h] = f(null), g = d(!1);
	l(() => {
		if (window.FB) {
			p(!0);
			return;
		}
		if (g.current) return;
		if (document.getElementById("facebook-jssdk")) {
			g.current = !0;
			return;
		}
		g.current = !0, window.fbAsyncInit = () => {
			window.FB?.init({
				appId: t,
				version: "v18.0",
				cookie: !0,
				xfbml: !1
			}), p(!0);
		};
		let e = document.createElement("script");
		e.id = "facebook-jssdk", e.src = "https://connect.facebook.net/en_US/sdk.js", e.async = !0, e.defer = !0, document.body.appendChild(e);
	}, [t]);
	let _ = s(async (e) => {
		if (e.status !== "connected" || !e.authResponse) {
			let t = /* @__PURE__ */ Error(e.status === "not_authorized" ? "Facebook login not authorized. Please grant permissions." : "Facebook login was cancelled or failed");
			h(t), c(!1), a(!1), r?.(t);
			return;
		}
		try {
			let t = await Qt({ accessToken: e.authResponse.accessToken }), r = await X(t.accessToken), a = W({
				...r,
				user_guid: r.user_guid || t.user.guid,
				email: r.email || t.user.email || void 0
			});
			i(t.accessToken, t.refreshToken, t.expiresIn, a), n?.(t, a);
		} catch (e) {
			let t = e instanceof Error ? e : /* @__PURE__ */ Error("Facebook authentication failed");
			h(t), a(!1), r?.(t);
		} finally {
			c(!1);
		}
	}, [
		i,
		a,
		n,
		r
	]);
	return {
		login: s(() => {
			if (!u || !window.FB) {
				let e = /* @__PURE__ */ Error("Facebook SDK not ready. Please try again.");
				h(e), r?.(e);
				return;
			}
			c(!0), a(!0), h(null), window.FB.getLoginStatus((e) => {
				e.status === "connected" && e.authResponse ? _(e) : window.FB.login((e) => {
					_(e);
				}, { scope: "email,public_profile" });
			});
		}, [
			u,
			_,
			a,
			r
		]),
		isLoading: o,
		isReady: u,
		error: m
	};
}
//#endregion
//#region ../node_modules/zod/v4/core/core.js
var Cn;
function wn(e, t, n) {
	function r(n, r) {
		if (n._zod || Object.defineProperty(n, "_zod", {
			value: {
				def: r,
				constr: o,
				traits: /* @__PURE__ */ new Set()
			},
			enumerable: !1
		}), n._zod.traits.has(e)) return;
		n._zod.traits.add(e), t(n, r);
		let i = o.prototype, a = Object.keys(i);
		for (let e = 0; e < a.length; e++) {
			let t = a[e];
			t in n || (n[t] = i[t].bind(n));
		}
	}
	let i = n?.Parent ?? Object;
	class a extends i {}
	Object.defineProperty(a, "name", { value: e });
	function o(e) {
		var t;
		let i = n?.Parent ? new a() : this;
		r(i, e), (t = i._zod).deferred ?? (t.deferred = []);
		for (let e of i._zod.deferred) e();
		return i;
	}
	return Object.defineProperty(o, "init", { value: r }), Object.defineProperty(o, Symbol.hasInstance, { value: (t) => n?.Parent && t instanceof n.Parent ? !0 : t?._zod?.traits?.has(e) }), Object.defineProperty(o, "name", { value: e }), o;
}
var Tn = class extends Error {
	constructor() {
		super("Encountered Promise during synchronous parse. Use .parseAsync() instead.");
	}
};
(Cn = globalThis).__zod_globalConfig ?? (Cn.__zod_globalConfig = {});
var En = globalThis.__zod_globalConfig;
function Dn(e) {
	return e && Object.assign(En, e), En;
}
//#endregion
//#region ../node_modules/zod/v4/core/util.js
function On(e, t) {
	return typeof t == "bigint" ? t.toString() : t;
}
var kn = "captureStackTrace" in Error ? Error.captureStackTrace : (...e) => {};
-Number.MAX_VALUE, Number.MAX_VALUE;
function An(e) {
	return typeof e == "string" ? e : e?.message;
}
function jn(e, t, n) {
	let r = e.message ? e.message : An(e.inst?._zod.def?.error?.(e)) ?? An(t?.error?.(e)) ?? An(n.customError?.(e)) ?? An(n.localeError?.(e)) ?? "Invalid input", { inst: i, continue: a, input: o, ...s } = e;
	return s.path ??= [], s.message = r, t?.reportInput && (s.input = o), s;
}
//#endregion
//#region ../node_modules/zod/v4/core/errors.js
var Mn = (e, t) => {
	e.name = "$ZodError", Object.defineProperty(e, "_zod", {
		value: e._zod,
		enumerable: !1
	}), Object.defineProperty(e, "issues", {
		value: t,
		enumerable: !1
	}), e.message = JSON.stringify(t, On, 2), Object.defineProperty(e, "toString", {
		value: () => e.message,
		enumerable: !1
	});
}, Nn = wn("$ZodError", Mn), Pn = /* @__PURE__*/ ((e) => (t, n, r, i) => {
	let a = r ? {
		...r,
		async: !1
	} : { async: !1 }, o = t._zod.run({
		value: n,
		issues: []
	}, a);
	if (o instanceof Promise) throw new Tn();
	if (o.issues.length) {
		let t = new (i?.Err ?? e)(o.issues.map((e) => jn(e, a, Dn())));
		throw kn(t, i?.callee), t;
	}
	return o.value;
})(wn("$ZodError", Mn, { Parent: Error }));
//#endregion
//#region ../node_modules/mantine-form-zod-resolver/dist/esm/index.mjs
function Fn(e, t) {
	return (n) => {
		try {
			return Pn(e, n), {};
		} catch (e) {
			if (e instanceof Nn) {
				let n = {};
				return t?.errorPriority === "first" && e.issues.reverse(), e.issues.forEach((e) => {
					n[e.path.join(".")] = e.message;
				}), n;
			}
			throw e;
		}
	};
}
//#endregion
//#region src/utils/describeOAuthError.ts
function In(e, t) {
	if (e instanceof Y) switch (e.status) {
		case 401: return t("oauth.errors.session_expired");
		case 422: return t("oauth.errors.malformed_link");
		case 429: return t("oauth.errors.rate_limited");
		case 503: return t("oauth.errors.service_unavailable");
		case 0: return t("oauth.errors.network");
		default: return e.message || t("oauth.errors.generic");
	}
	return e instanceof Error ? e.message : t("oauth.errors.generic");
}
//#endregion
//#region src/components/GoogleLoginButton/GoogleLoginButton.tsx
function Ln(e) {
	if (e) return e.startsWith("/") && !e.startsWith("//") ? e : void 0;
}
function Rn({ returnUrl: e, onError: t, label: n, iconOnly: r = !1, ...i }) {
	let { t: a } = F("auth"), [o, c] = f(!1), [l, u] = f(null), d = s(async () => {
		c(!0), u(null);
		try {
			let { authorizationUrl: t } = await Yt(Ln(e));
			window.location.assign(t);
		} catch (e) {
			c(!1), u(In(e, a)), t?.(e instanceof Error ? e : Error(a("oauth.errors.generic")));
		}
	}, [
		e,
		t,
		a
	]), p = n ?? a("oauth.google.button", "Sign in with Google");
	return /* @__PURE__ */ R(I, { children: [/* @__PURE__ */ L(_, {
		leftSection: r ? void 0 : /* @__PURE__ */ L(se, { size: 18 }),
		onClick: d,
		loading: o,
		variant: "default",
		...i,
		"aria-label": p,
		"data-testid": "google-login-button",
		children: r ? /* @__PURE__ */ L(se, { size: 18 }) : p
	}), l && /* @__PURE__ */ L(A, {
		size: "xs",
		c: "red",
		"data-testid": "google-login-error",
		children: l
	})] });
}
//#endregion
//#region src/components/FacebookLoginButton/FacebookLoginButton.tsx
function zn({ appId: e, onSuccess: t, onError: n, label: r, iconOnly: i = !1, ...a }) {
	let { t: o } = F("auth"), { login: s, isLoading: c, isReady: l } = Sn({
		appId: e,
		onSuccess: t,
		onError: n
	}), u = r ?? o("oauth.facebook.button", "Sign in with Facebook");
	return i ? /* @__PURE__ */ L(_, {
		onClick: s,
		loading: c,
		disabled: !l,
		variant: "default",
		...a,
		"aria-label": u,
		"data-testid": "facebook-login-button",
		children: /* @__PURE__ */ L(oe, { size: 18 })
	}) : /* @__PURE__ */ L(_, {
		leftSection: /* @__PURE__ */ L(oe, { size: 18 }),
		onClick: s,
		loading: c,
		disabled: !l,
		variant: "default",
		...a,
		"aria-label": u,
		"data-testid": "facebook-login-button",
		children: u
	});
}
//#endregion
//#region src/components/TelegramLoginButton/TelegramIcon.tsx
function Bn({ size: e = 18, ...t }) {
	return /* @__PURE__ */ L("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: e,
		height: e,
		viewBox: "84 154 760 760",
		fill: "currentColor",
		"aria-hidden": "true",
		focusable: "false",
		"data-testid": "telegram-icon",
		...t,
		children: /* @__PURE__ */ L("path", { d: "M226.328419,494.722069 C372.088573,431.216685 469.284839,389.350049 517.917216,369.122161 C656.772535,311.36743 685.625481,301.334815 704.431427,301.003532 C708.567621,300.93067 717.815839,301.955743 723.806446,306.816707 C728.864797,310.92121 730.256552,316.46581 730.922551,320.357329 C731.588551,324.248848 732.417879,333.113828 731.758626,340.040666 C724.234007,419.102486 691.675104,610.964674 675.110982,699.515267 C668.10208,736.984342 654.301336,749.547532 640.940618,750.777006 C611.904684,753.448938 589.856115,731.588035 561.733393,713.153237 C517.726886,684.306416 492.866009,666.349181 450.150074,638.200013 C400.78442,605.66878 432.786119,587.789048 460.919462,558.568563 C468.282091,550.921423 596.21508,434.556479 598.691227,424.000355 C599.00091,422.680135 599.288312,417.758981 596.36474,415.160431 C593.441168,412.561881 589.126229,413.450484 586.012448,414.157198 C581.598758,415.158943 511.297793,461.625274 375.109553,553.556189 C355.154858,567.258623 337.080515,573.934908 320.886524,573.585046 C303.033948,573.199351 268.692754,563.490928 243.163606,555.192408 C211.851067,545.013936 186.964484,539.632504 189.131547,522.346309 C190.260287,513.342589 202.659244,504.134509 226.328419,494.722069 Z" })
	});
}
//#endregion
//#region src/components/TelegramLoginButton/TelegramLoginButton.tsx
function Vn(e) {
	if (e) return e.startsWith("/") && !e.startsWith("//") ? e : void 0;
}
function Hn({ returnUrl: e, onError: t, label: n, iconOnly: r = !1, ...i }) {
	let { t: a } = F("auth"), [o, c] = f(!1), [l, u] = f(null), d = s(async () => {
		c(!0), u(null);
		try {
			let { authorizationUrl: t } = await $t(Vn(e));
			window.location.assign(t);
		} catch (e) {
			c(!1), u(In(e, a)), t?.(e instanceof Error ? e : Error(a("oauth.errors.generic")));
		}
	}, [
		e,
		t,
		a
	]), p = n ?? a("oauth.telegram.button", "Log in with Telegram");
	return /* @__PURE__ */ R(I, { children: [/* @__PURE__ */ L(_, {
		leftSection: r ? void 0 : /* @__PURE__ */ L(Bn, { size: 18 }),
		onClick: d,
		loading: o,
		variant: "default",
		...i,
		"aria-label": p,
		"data-testid": "telegram-login-button",
		children: r ? /* @__PURE__ */ L(Bn, { size: 18 }) : p
	}), l && /* @__PURE__ */ L(A, {
		size: "xs",
		c: "red",
		"data-testid": "telegram-login-error",
		children: l
	})] });
}
//#endregion
//#region src/components/SocialLoginButtons/SocialLoginButtons.tsx
function Un({ google: e = !0, facebook: t = !0, telegram: n = !0, facebookAppId: r, returnUrl: i, onSuccess: a, onError: o, showDivider: s = !0, dividerText: c, layout: l = "vertical", ...u }) {
	let { t: d } = F("auth");
	t && !r && console.warn("SocialLoginButtons: facebookAppId is required when facebook=true");
	let f = (e) => (t, n) => {
		a?.(t, n, e);
	}, p = (e) => (t) => {
		o?.(t, e);
	};
	if ([
		e,
		t && r,
		n
	].filter(Boolean).length === 0) return null;
	let m = /* @__PURE__ */ R(I, { children: [
		e && /* @__PURE__ */ L(Rn, {
			returnUrl: i,
			onError: p("google"),
			fullWidth: l === "vertical"
		}),
		t && r && /* @__PURE__ */ L(zn, {
			appId: r,
			onSuccess: f("facebook"),
			onError: p("facebook"),
			fullWidth: l === "vertical"
		}),
		n && /* @__PURE__ */ L(Hn, {
			returnUrl: i,
			onError: p("telegram"),
			fullWidth: l === "vertical"
		})
	] });
	return /* @__PURE__ */ R(k, {
		gap: "sm",
		...u,
		"data-testid": "social-login-buttons",
		children: [s && /* @__PURE__ */ L(b, {
			label: /* @__PURE__ */ L(A, {
				size: "sm",
				c: "dimmed",
				children: c || d("oauth.divider", "or")
			}),
			labelPosition: "center"
		}), l === "vertical" ? /* @__PURE__ */ L(k, {
			gap: "xs",
			children: m
		}) : /* @__PURE__ */ L(x, {
			gap: "xs",
			justify: "center",
			children: m
		})]
	});
}
//#endregion
//#region src/components/LoginForm/LoginForm.tsx
var Wn = P.object({
	email: P.string().min(1, "login.errors.email_required").email("login.errors.email_invalid"),
	password: P.string().min(1, "login.errors.password_required")
}), Gn = P.object({
	email: P.string().min(1, "login.errors.email_required").email("login.errors.email_invalid"),
	code: P.string().min(6, "login.errors.code_invalid").max(6, "login.errors.code_invalid")
});
function Kn({ onSuccess: e, onError: t, disabled: n = !1, showSocialLogin: r = !0, facebookAppId: i, returnUrl: a, onSocialSuccess: o, onSocialError: c, showCodeLogin: u = !0, defaultMethod: d = "password" }) {
	let { t: h } = F("auth"), { loginWithCredentials: g, loginByCode: v, isLoading: y } = pn(), [x, S] = f(null), [C, w] = f(d), [T, D] = f(!1), [ee, te] = f(!1), M = re({
		initialValues: {
			email: "",
			password: ""
		},
		validate: Fn(Wn)
	}), N = re({
		initialValues: {
			email: "",
			code: ""
		},
		validate: Fn(Gn)
	});
	l(() => {
		C === "code" ? N.setFieldValue("email", M.values.email) : M.setFieldValue("email", N.values.email), S(null);
	}, [C]);
	let ne = s(async (n) => {
		S(null);
		try {
			let t = await g({
				email: n.email,
				password: n.password
			});
			e?.(t);
		} catch (e) {
			let n = qn(e, h);
			S(n), t?.(e instanceof Error ? e : Error(n));
		}
	}, [
		g,
		e,
		t,
		h
	]), ae = s(async () => {
		if (!N.validateField("email").hasError) {
			S(null), te(!0);
			try {
				await Kt(N.values.email), D(!0);
			} catch (e) {
				S(Jn(e, h));
			} finally {
				te(!1);
			}
		}
	}, [N, h]), oe = s(async (n) => {
		S(null);
		try {
			let t = await v(n.email, n.code);
			e?.(t);
		} catch (e) {
			let n = Jn(e, h);
			S(n), t?.(e instanceof Error ? e : Error(n));
		}
	}, [
		v,
		e,
		t,
		h
	]), se = s(() => {
		D(!1), N.setFieldValue("code", ""), S(null);
	}, [N]), ce = s((t, n, r) => {
		e?.(n), o?.(t, r);
	}, [e, o]), le = y || n;
	return /* @__PURE__ */ R(k, {
		gap: "md",
		children: [
			r && /* @__PURE__ */ R(I, { children: [/* @__PURE__ */ L(Un, {
				facebookAppId: i,
				returnUrl: a,
				onSuccess: ce,
				onError: c,
				showDivider: !1
			}), /* @__PURE__ */ L(b, {
				label: /* @__PURE__ */ L(A, {
					size: "sm",
					c: "dimmed",
					children: h("login.or_with_email")
				}),
				labelPosition: "center"
			})] }),
			x && /* @__PURE__ */ L(p, {
				icon: /* @__PURE__ */ L(ie, { size: 16 }),
				color: "red",
				variant: "light",
				title: h("login.error_title"),
				"aria-live": "polite",
				"data-testid": "login-error",
				children: x
			}),
			u && /* @__PURE__ */ L(O, {
				value: C,
				onChange: (e) => w(e),
				data: [{
					label: h("login.method_password"),
					value: "password"
				}, {
					label: h("login.method_code"),
					value: "code"
				}],
				fullWidth: !0,
				"data-testid": "login-method-toggle"
			}),
			C === "password" && /* @__PURE__ */ L("form", {
				onSubmit: M.onSubmit(ne),
				noValidate: !0,
				children: /* @__PURE__ */ R(k, {
					gap: "md",
					children: [
						/* @__PURE__ */ L(j, {
							label: h("login.email_label"),
							placeholder: h("login.email_placeholder"),
							leftSection: /* @__PURE__ */ L(me, { size: 16 }),
							autoComplete: "email",
							type: "email",
							inputMode: "email",
							"data-autofocus": !0,
							"data-testid": "login-email",
							"aria-label": h("login.email_label"),
							"aria-required": "true",
							"aria-invalid": !!M.errors.email,
							disabled: le,
							...M.getInputProps("email"),
							error: M.errors.email ? h(M.errors.email) : void 0
						}),
						/* @__PURE__ */ L(E, {
							label: h("login.password_label"),
							placeholder: h("login.password_placeholder"),
							leftSection: /* @__PURE__ */ L(fe, { size: 16 }),
							autoComplete: "current-password",
							"data-testid": "login-password",
							"aria-label": h("login.password_label"),
							"aria-required": "true",
							"aria-invalid": !!M.errors.password,
							disabled: le,
							...M.getInputProps("password"),
							error: M.errors.password ? h(M.errors.password) : void 0
						}),
						/* @__PURE__ */ L(_, {
							type: "submit",
							fullWidth: !0,
							loading: y,
							disabled: n,
							"data-testid": "login-submit",
							mt: "xs",
							children: h("login.submit")
						})
					]
				})
			}),
			C === "code" && /* @__PURE__ */ L("form", {
				onSubmit: N.onSubmit(oe),
				noValidate: !0,
				children: /* @__PURE__ */ R(k, {
					gap: "md",
					children: [/* @__PURE__ */ L(j, {
						label: h("login.email_label"),
						placeholder: h("login.email_placeholder"),
						leftSection: /* @__PURE__ */ L(me, { size: 16 }),
						autoComplete: "email",
						type: "email",
						inputMode: "email",
						"data-autofocus": !0,
						"data-testid": "login-email",
						"aria-label": h("login.email_label"),
						"aria-required": "true",
						"aria-invalid": !!N.errors.email,
						disabled: le || T,
						...N.getInputProps("email"),
						error: N.errors.email ? h(N.errors.email) : void 0
					}), T ? /* @__PURE__ */ R(I, { children: [
						/* @__PURE__ */ L(A, {
							size: "sm",
							c: "teal",
							"data-testid": "login-code-sent-msg",
							children: h("login.code_sent")
						}),
						/* @__PURE__ */ L(j, {
							label: h("login.code"),
							placeholder: "000000",
							leftSection: /* @__PURE__ */ L(he, { size: 16 }),
							autoComplete: "one-time-code",
							inputMode: "numeric",
							maxLength: 6,
							"data-testid": "login-code",
							"aria-label": h("login.code"),
							"aria-required": "true",
							"aria-invalid": !!N.errors.code,
							disabled: le,
							...N.getInputProps("code"),
							error: N.errors.code ? h(N.errors.code) : void 0
						}),
						/* @__PURE__ */ L(_, {
							type: "submit",
							fullWidth: !0,
							loading: y,
							disabled: n,
							"data-testid": "login-submit",
							mt: "xs",
							children: h("login.verify_and_sign_in")
						}),
						/* @__PURE__ */ L(m, {
							component: "button",
							type: "button",
							size: "sm",
							ta: "center",
							onClick: se,
							"data-testid": "login-resend-code",
							children: h("login.resend_code")
						})
					] }) : /* @__PURE__ */ L(_, {
						fullWidth: !0,
						variant: "light",
						loading: ee,
						disabled: n,
						onClick: ae,
						"data-testid": "login-send-code",
						mt: "xs",
						children: h("login.send_code")
					})]
				})
			})
		]
	});
}
function qn(e, t) {
	if (e instanceof Y) switch (e.code) {
		case "INVALID_CREDENTIALS": return t("login.errors.invalid_credentials");
		case "ACCOUNT_LOCKED": return t("login.errors.account_locked");
		case "ACCOUNT_DISABLED": return t("login.errors.account_disabled");
		case "EMAIL_NOT_VERIFIED": return t("login.errors.email_not_verified");
		default: return e.message || t("login.errors.generic");
	}
	return e instanceof Error && e.message || t("login.errors.generic");
}
function Jn(e, t) {
	if (e instanceof Y) switch (e.code) {
		case "CODE_EXPIRED": return t("login.errors.code_expired");
		case "RATE_LIMITED": return t("login.errors.code_rate_limited");
		case "INVALID_CODE": {
			let n = e.details?.remaining;
			return n === void 0 ? t("login.errors.code_invalid_value", { remaining: "?" }) : t("login.errors.code_invalid_value", { remaining: n });
		}
		default: return e.message || t("login.errors.code_send_failed");
	}
	return e instanceof Error && e.message || t("login.errors.code_send_failed");
}
//#endregion
//#region src/components/LoginModal/LoginModal.tsx
function Yn({ opened: e, onClose: t, onSuccess: n, onError: r, title: i, subtitle: a, closeOnSuccess: o = !0, size: c = "sm", centered: l = !0, showSocialLogin: u = !1, showCodeLogin: d, defaultMethod: f, facebookAppId: p, returnUrl: m }) {
	let { t: h } = F("auth"), g = s((e) => {
		n?.(e), o && t();
	}, [
		n,
		t,
		o
	]);
	return /* @__PURE__ */ L(w, {
		opened: e,
		onClose: t,
		title: i || h("login.modal_title"),
		size: c,
		centered: l,
		trapFocus: !0,
		closeOnEscape: !0,
		closeOnClickOutside: !0,
		"aria-labelledby": "login-modal-title",
		"data-testid": "login-modal",
		children: /* @__PURE__ */ R(k, {
			gap: "md",
			children: [a && /* @__PURE__ */ L(A, {
				size: "sm",
				c: "dimmed",
				ta: "center",
				children: a
			}), /* @__PURE__ */ L(Kn, {
				onSuccess: g,
				onError: r,
				showSocialLogin: u,
				showCodeLogin: d,
				defaultMethod: f,
				facebookAppId: p,
				returnUrl: m
			})]
		})
	});
}
//#endregion
//#region src/components/LoginPage/LoginPage.tsx
function Xn({ onSuccess: e, onError: t, redirectOnSuccess: n, logo: r, backgroundImage: i, title: a, subtitle: o, maxWidth: c = 420, showSocialLogin: l = !1, showCodeLogin: u, defaultMethod: d, facebookAppId: f, returnUrl: p }) {
	let { t: m } = F("auth"), h = ne(), _ = N("light") === "dark", y = s((t) => {
		e?.(t), n && typeof window < "u" && (window.location.href = n);
	}, [e, n]);
	return /* @__PURE__ */ L(v, {
		mih: "100vh",
		style: {
			...i ? {
				backgroundImage: `url(${i})`,
				backgroundSize: "cover",
				backgroundPosition: "center",
				backgroundRepeat: "no-repeat"
			} : {},
			backgroundColor: i ? void 0 : _ ? h.colors.dark[8] : h.colors.gray[0]
		},
		"data-testid": "login-page",
		children: /* @__PURE__ */ L(g, {
			w: {
				base: "100%",
				sm: c
			},
			px: "md",
			py: "xl",
			children: /* @__PURE__ */ R(k, {
				gap: "lg",
				align: "center",
				children: [
					r && /* @__PURE__ */ L(g, {
						mb: "md",
						"data-testid": "login-page-logo",
						children: r
					}),
					/* @__PURE__ */ L(T, {
						p: "xl",
						shadow: "md",
						radius: "md",
						withBorder: !0,
						w: "100%",
						style: i ? {
							backgroundColor: "rgba(255, 255, 255, 0.95)",
							backdropFilter: "blur(10px)"
						} : void 0,
						children: /* @__PURE__ */ R(k, {
							gap: "md",
							children: [
								/* @__PURE__ */ L(te, {
									order: 2,
									ta: "center",
									"data-testid": "login-page-title",
									children: a || m("login.page_title")
								}),
								(o || !a) && /* @__PURE__ */ L(A, {
									size: "sm",
									c: "dimmed",
									ta: "center",
									children: o || m("login.page_subtitle")
								}),
								/* @__PURE__ */ L(Kn, {
									onSuccess: y,
									onError: t,
									showSocialLogin: l,
									showCodeLogin: u,
									defaultMethod: d,
									facebookAppId: f,
									returnUrl: p
								})
							]
						})
					}),
					/* @__PURE__ */ L(A, {
						size: "xs",
						c: "dimmed",
						ta: "center",
						children: m("login.help_text")
					})
				]
			})
		})
	});
}
//#endregion
//#region src/components/RegisterForm/PasswordStrengthIndicator.tsx
function Zn(e) {
	return [
		{
			key: "length",
			label: "password.requirements.length",
			met: e.length >= 8
		},
		{
			key: "uppercase",
			label: "password.requirements.uppercase",
			met: /[A-Z]/.test(e)
		},
		{
			key: "lowercase",
			label: "password.requirements.lowercase",
			met: /[a-z]/.test(e)
		},
		{
			key: "number",
			label: "password.requirements.number",
			met: /[0-9]/.test(e)
		}
	];
}
function Qn(e) {
	if (!e) return 0;
	let t = Zn(e), n = t.filter((e) => e.met).length / t.length * 80, r = /[!@#$%^&*(),.?":{}|<>]/.test(e) ? 10 : 0, i = Math.min(10, Math.max(0, e.length - 8));
	return Math.min(100, n + r + i);
}
function $n(e) {
	return e < 30 ? "red" : e < 60 ? "yellow" : e < 80 ? "lime" : "green";
}
function er(e) {
	return e < 30 ? "password.strength.weak" : e < 60 ? "password.strength.fair" : e < 80 ? "password.strength.good" : "password.strength.strong";
}
function tr({ met: e, label: t }) {
	let { t: n } = F("auth");
	return /* @__PURE__ */ R(x, {
		gap: "xs",
		wrap: "nowrap",
		children: [/* @__PURE__ */ L(ee, {
			size: "xs",
			radius: "xl",
			color: e ? "green" : "red",
			variant: "light",
			children: L(e ? ce : ye, { size: 10 })
		}), /* @__PURE__ */ L(A, {
			size: "xs",
			c: e ? "dimmed" : void 0,
			style: { textDecoration: e ? "line-through" : void 0 },
			children: n(t)
		})]
	});
}
function nr({ password: e, showRequirements: t = !0, compact: n = !1 }) {
	let { t: r } = F("auth"), i = u(() => Qn(e), [e]), a = u(() => Zn(e), [e]), o = $n(i), s = er(i);
	return e ? n ? /* @__PURE__ */ L(D, {
		value: i,
		color: o,
		size: "xs",
		"aria-label": r("password.strength.label"),
		"aria-valuenow": i,
		"aria-valuemin": 0,
		"aria-valuemax": 100
	}) : /* @__PURE__ */ R(k, {
		gap: "xs",
		"data-testid": "password-strength-indicator",
		children: [
			/* @__PURE__ */ R(x, {
				justify: "space-between",
				gap: "xs",
				children: [/* @__PURE__ */ L(A, {
					size: "xs",
					c: "dimmed",
					children: r("password.strength.label")
				}), /* @__PURE__ */ L(A, {
					size: "xs",
					c: o,
					fw: 500,
					children: r(s)
				})]
			}),
			/* @__PURE__ */ L(D, {
				value: i,
				color: o,
				size: "sm",
				"aria-label": r("password.strength.label"),
				"aria-valuenow": i,
				"aria-valuemin": 0,
				"aria-valuemax": 100,
				"data-testid": "password-strength-progress"
			}),
			t && /* @__PURE__ */ L(g, {
				mt: "xs",
				children: /* @__PURE__ */ L(k, {
					gap: 4,
					children: a.map((e) => /* @__PURE__ */ L(tr, {
						met: e.met,
						label: e.label
					}, e.key))
				})
			})
		]
	}) : null;
}
//#endregion
//#region src/components/RegisterForm/RegisterForm.tsx
var rr = P.object({
	name: P.string().min(1, "register.errors.name_required").max(100, "register.errors.name_too_long"),
	email: P.string().min(1, "register.errors.email_required").email("register.errors.email_invalid"),
	password: P.string().min(8, "register.errors.password_min_length").refine((e) => /[A-Z]/.test(e), "register.errors.password_uppercase").refine((e) => /[a-z]/.test(e), "register.errors.password_lowercase").refine((e) => /[0-9]/.test(e), "register.errors.password_number"),
	confirmPassword: P.string().min(1, "register.errors.confirm_password_required"),
	acceptTerms: P.boolean().refine((e) => e === !0, "register.errors.terms_required")
}).refine((e) => e.password === e.confirmPassword, {
	message: "register.errors.passwords_mismatch",
	path: ["confirmPassword"]
});
function ir({ onSuccess: e, onError: t, showLogin: n = !1, onLoginClick: r, termsUrl: i = "/terms", privacyUrl: a = "/privacy", submitLabel: o, disabled: c = !1, showPasswordStrength: l = !0, showSocialLogin: u = !1, facebookAppId: d, returnUrl: h, onSocialSuccess: g, onSocialError: v }) {
	let { t: S } = F("auth"), [C, w] = f(!1), [T, D] = f(null), O = re({
		initialValues: {
			name: "",
			email: "",
			password: "",
			confirmPassword: "",
			acceptTerms: !1
		},
		validate: Fn(rr)
	}), ee = s((e) => Zn(e).every((e) => e.met), []), te = s(async (n) => {
		D(null), w(!0);
		try {
			await Ut({
				email: n.email,
				password: n.password,
				firstName: n.name.split(" ")[0],
				lastName: n.name.split(" ").slice(1).join(" ") || void 0
			}), e?.();
		} catch (e) {
			let n;
			if (e instanceof Y) switch (e.code) {
				case "EMAIL_EXISTS":
				case "USER_EXISTS":
					n = S("register.errors.email_exists");
					break;
				case "VALIDATION_ERROR":
					n = S("register.errors.validation_error");
					break;
				case "RATE_LIMITED":
					n = S("register.errors.rate_limited");
					break;
				default: n = e.message || S("register.errors.generic");
			}
			else n = e instanceof Error && e.message || S("register.errors.generic");
			D(n), t?.(e instanceof Error ? e : Error(n));
		} finally {
			w(!1);
		}
	}, [
		e,
		t,
		S
	]), M = C || c, N = O.values.password && !ee(O.values.password), ne = s((t, n, r) => {
		e?.(n), g?.(t, r);
	}, [e, g]);
	return /* @__PURE__ */ L("form", {
		onSubmit: O.onSubmit(te),
		noValidate: !0,
		children: /* @__PURE__ */ R(k, {
			gap: "md",
			children: [
				u && /* @__PURE__ */ R(I, { children: [/* @__PURE__ */ L(Un, {
					facebookAppId: d,
					returnUrl: h,
					onSuccess: ne,
					onError: v,
					showDivider: !1
				}), /* @__PURE__ */ L(b, {
					label: /* @__PURE__ */ L(A, {
						size: "sm",
						c: "dimmed",
						children: S("register.or_email", "or with email")
					}),
					labelPosition: "center"
				})] }),
				T && /* @__PURE__ */ L(p, {
					icon: /* @__PURE__ */ L(ie, { size: 16 }),
					color: "red",
					variant: "light",
					title: S("register.error_title"),
					"aria-live": "polite",
					"data-testid": "register-error",
					children: T
				}),
				/* @__PURE__ */ L(j, {
					label: S("register.name_label"),
					placeholder: S("register.name_placeholder"),
					leftSection: /* @__PURE__ */ L(_e, { size: 16 }),
					autoComplete: "name",
					"data-autofocus": !0,
					"data-testid": "register-name",
					"aria-label": S("register.name_label"),
					"aria-required": "true",
					"aria-invalid": !!O.errors.name,
					disabled: M,
					...O.getInputProps("name"),
					error: O.errors.name ? S(O.errors.name) : void 0
				}),
				/* @__PURE__ */ L(j, {
					label: S("register.email_label"),
					placeholder: S("register.email_placeholder"),
					leftSection: /* @__PURE__ */ L(me, { size: 16 }),
					autoComplete: "email",
					type: "email",
					inputMode: "email",
					"data-testid": "register-email",
					"aria-label": S("register.email_label"),
					"aria-required": "true",
					"aria-invalid": !!O.errors.email,
					disabled: M,
					...O.getInputProps("email"),
					error: O.errors.email ? S(O.errors.email) : void 0
				}),
				/* @__PURE__ */ R(k, {
					gap: "xs",
					children: [/* @__PURE__ */ L(E, {
						label: S("register.password_label"),
						placeholder: S("register.password_placeholder"),
						leftSection: /* @__PURE__ */ L(fe, { size: 16 }),
						autoComplete: "new-password",
						"data-testid": "register-password",
						"aria-label": S("register.password_label"),
						"aria-required": "true",
						"aria-invalid": !!O.errors.password,
						"aria-describedby": "password-requirements",
						disabled: M,
						...O.getInputProps("password"),
						error: O.errors.password ? S(O.errors.password) : void 0
					}), l && /* @__PURE__ */ L("div", {
						id: "password-requirements",
						children: /* @__PURE__ */ L(nr, {
							password: O.values.password,
							showRequirements: !0
						})
					})]
				}),
				/* @__PURE__ */ L(E, {
					label: S("register.confirm_password_label"),
					placeholder: S("register.confirm_password_placeholder"),
					leftSection: /* @__PURE__ */ L(fe, { size: 16 }),
					autoComplete: "new-password",
					"data-testid": "register-confirm-password",
					"aria-label": S("register.confirm_password_label"),
					"aria-required": "true",
					"aria-invalid": !!O.errors.confirmPassword,
					disabled: M,
					...O.getInputProps("confirmPassword"),
					error: O.errors.confirmPassword ? S(O.errors.confirmPassword) : void 0
				}),
				/* @__PURE__ */ L(y, {
					label: /* @__PURE__ */ R(I, { children: [
						S("register.terms_prefix"),
						" ",
						/* @__PURE__ */ L(m, {
							href: i,
							target: "_blank",
							size: "sm",
							children: S("register.terms_link")
						}),
						" ",
						S("register.terms_and"),
						" ",
						/* @__PURE__ */ L(m, {
							href: a,
							target: "_blank",
							size: "sm",
							children: S("register.privacy_link")
						})
					] }),
					"data-testid": "register-terms",
					"aria-required": "true",
					"aria-invalid": !!O.errors.acceptTerms,
					disabled: M,
					...O.getInputProps("acceptTerms", { type: "checkbox" }),
					error: O.errors.acceptTerms ? S(O.errors.acceptTerms) : void 0
				}),
				/* @__PURE__ */ L(_, {
					type: "submit",
					fullWidth: !0,
					loading: C,
					disabled: c || !!N,
					"data-testid": "register-submit",
					mt: "xs",
					children: o || S("register.submit")
				}),
				n && /* @__PURE__ */ L(x, {
					justify: "center",
					mt: "xs",
					children: /* @__PURE__ */ L(m, {
						component: "button",
						type: "button",
						size: "sm",
						onClick: r,
						"data-testid": "register-login-link",
						children: S("register.have_account")
					})
				})
			]
		})
	});
}
//#endregion
//#region src/components/RegisterModal/VerificationSuccess.tsx
function ar({ email: e, onResendClick: t, onLoginClick: n, title: r, message: i }) {
	let { t: a } = F("auth"), [o, c] = f(!1), [l, u] = f(!1), [d, h] = f(null), g = s(async () => {
		if (t) {
			c(!0), u(!1), h(null);
			try {
				await t(), u(!0);
			} catch (e) {
				h(e instanceof Error ? e.message : a("register.verification.resend_error"));
			} finally {
				c(!1);
			}
		}
	}, [t, a]);
	return /* @__PURE__ */ R(k, {
		gap: "lg",
		align: "center",
		"data-testid": "verification-success",
		children: [
			/* @__PURE__ */ L(v, { children: /* @__PURE__ */ L(ee, {
				size: 80,
				radius: 80,
				variant: "light",
				color: "green",
				"aria-hidden": "true",
				children: /* @__PURE__ */ L(me, { size: 40 })
			}) }),
			/* @__PURE__ */ R(k, {
				gap: "xs",
				align: "center",
				children: [/* @__PURE__ */ L(A, {
					size: "xl",
					fw: 600,
					ta: "center",
					children: r || a("register.verification.title")
				}), /* @__PURE__ */ L(A, {
					size: "sm",
					c: "dimmed",
					ta: "center",
					maw: 400,
					children: i || a("register.verification.message", { email: e })
				})]
			}),
			l && /* @__PURE__ */ L(p, {
				icon: /* @__PURE__ */ L(ce, { size: 16 }),
				color: "green",
				variant: "light",
				w: "100%",
				"data-testid": "resend-success",
				children: a("register.verification.resend_success")
			}),
			d && /* @__PURE__ */ L(p, {
				icon: /* @__PURE__ */ L(ie, { size: 16 }),
				color: "red",
				variant: "light",
				w: "100%",
				"data-testid": "resend-error",
				children: d
			}),
			/* @__PURE__ */ R(k, {
				gap: "md",
				w: "100%",
				children: [t && /* @__PURE__ */ L(_, {
					variant: "light",
					fullWidth: !0,
					loading: o,
					disabled: l,
					onClick: g,
					"data-testid": "resend-verification",
					children: a(l ? "register.verification.resend_sent" : "register.verification.resend_button")
				}), n && /* @__PURE__ */ L(v, { children: /* @__PURE__ */ L(m, {
					component: "button",
					type: "button",
					size: "sm",
					onClick: n,
					"data-testid": "back-to-login",
					children: a("register.verification.back_to_login")
				}) })]
			})
		]
	});
}
//#endregion
//#region src/components/RegisterModal/RegisterModal.tsx
function or({ opened: e, onClose: t, onSuccess: n, onError: r, showLogin: i = !1, onLoginClick: a, termsUrl: o, privacyUrl: c, onResendVerification: l, title: u, subtitle: d, size: p = "sm", centered: m = !0, showSocialLogin: h = !1, facebookAppId: g, returnUrl: _ }) {
	let { t: v } = F("auth"), [y, b] = f(!1), [x, S] = f(""), C = s(() => {
		n?.(), b(!0);
	}, [n]), T = s(() => {
		a && a(), t();
	}, [a, t]), E = s(async () => {
		l && x && await l(x);
	}, [l, x]), D = s(() => {
		b(!1), S(""), t();
	}, [t]), O = s(() => {
		C();
	}, [C]);
	return /* @__PURE__ */ L(w, {
		opened: e,
		onClose: D,
		title: y ? v("register.verification.title") : u || v("register.modal_title"),
		size: p,
		centered: m,
		trapFocus: !0,
		closeOnEscape: !0,
		closeOnClickOutside: !y,
		"aria-labelledby": "register-modal-title",
		"data-testid": "register-modal",
		children: /* @__PURE__ */ R(k, {
			gap: "md",
			children: [!y && d && /* @__PURE__ */ L(A, {
				size: "sm",
				c: "dimmed",
				ta: "center",
				children: d
			}), y ? /* @__PURE__ */ L(ar, {
				email: x,
				onResendClick: l ? E : void 0,
				onLoginClick: T
			}) : /* @__PURE__ */ L(sr, {
				onSuccess: O,
				onError: r,
				onEmailCapture: S,
				showLogin: i,
				onLoginClick: T,
				termsUrl: o,
				privacyUrl: c,
				showSocialLogin: h,
				facebookAppId: g,
				returnUrl: _
			})]
		})
	});
}
function sr({ onSuccess: e, onError: t, onEmailCapture: n, ...r }) {
	return /* @__PURE__ */ L("div", {
		onSubmitCapture: s((e) => {
			let t = e.currentTarget.querySelector("form");
			if (t) {
				let e = t.querySelector("[data-testid=\"register-email\"]");
				e && n(e.value);
			}
		}, [n]),
		children: /* @__PURE__ */ L(ir, {
			onSuccess: e,
			onError: t,
			...r
		})
	});
}
//#endregion
//#region src/components/AuthGuard/UnauthorizedFallback.tsx
function cr({ title: e, message: t, showBackButton: n = !0, showHomeButton: r = !0, homeUrl: i = "/", onBack: a, onHome: o }) {
	let { t: s } = F("auth");
	return /* @__PURE__ */ R(k, {
		align: "center",
		justify: "center",
		gap: "xl",
		mih: 400,
		p: "xl",
		children: [
			/* @__PURE__ */ L(ee, {
				size: 80,
				radius: "xl",
				variant: "light",
				color: "red",
				children: /* @__PURE__ */ L(fe, { size: 40 })
			}),
			/* @__PURE__ */ R(k, {
				align: "center",
				gap: "xs",
				children: [/* @__PURE__ */ L(te, {
					order: 2,
					ta: "center",
					children: e || s("guard.unauthorized_title", "Access Denied")
				}), /* @__PURE__ */ L(A, {
					c: "dimmed",
					ta: "center",
					maw: 400,
					children: t || s("guard.unauthorized_message", "You don't have permission to access this page.")
				})]
			}),
			/* @__PURE__ */ R(x, {
				gap: "md",
				children: [n && /* @__PURE__ */ L(_, {
					variant: "default",
					leftSection: /* @__PURE__ */ L(ae, { size: 16 }),
					onClick: () => {
						a ? a() : window.history.back();
					},
					children: s("guard.go_back", "Go Back")
				}), r && /* @__PURE__ */ L(_, {
					variant: "filled",
					leftSection: /* @__PURE__ */ L(ue, { size: 16 }),
					onClick: () => {
						o ? o() : window.location.href = i;
					},
					children: s("guard.go_home", "Go Home")
				})]
			})
		]
	});
}
//#endregion
//#region src/components/AuthGuard/LoadingFallback.tsx
function lr({ message: e, minHeight: t = "100vh", size: n = "lg" }) {
	let { t: r } = F("auth");
	return /* @__PURE__ */ L(v, {
		mih: t,
		children: /* @__PURE__ */ R(k, {
			align: "center",
			gap: "md",
			children: [/* @__PURE__ */ L(S, { size: n }), /* @__PURE__ */ L(A, {
				c: "dimmed",
				size: "sm",
				children: e || r("guard.loading", "Checking authentication...")
			})]
		})
	});
}
//#endregion
//#region src/components/AuthGuard/redirectUtils.ts
var ur = "returnTo", dr = 2e3;
function fr(e) {
	if (!e || typeof e != "string" || e.length > dr) return !1;
	try {
		if (e.startsWith("/")) return !e.startsWith("//");
		let t = new URL(e, window.location.origin), n = new URL(window.location.origin);
		if (t.origin !== n.origin) {
			let e = t.hostname;
			if (![".teletienda.ar", ".teletienda.local"].some((t) => e.endsWith(t) || e === t.slice(1))) return !1;
		}
		return !0;
	} catch {
		return !1;
	}
}
function pr(e, t) {
	if (!t || !fr(t)) return e;
	try {
		let n = new URL(e, window.location.origin);
		return n.searchParams.set(ur, t), n.origin === window.location.origin ? n.pathname + n.search : n.toString();
	} catch {
		return e;
	}
}
function mr() {
	try {
		let e = new URLSearchParams(window.location.search).get(ur);
		return e && fr(e) ? e : null;
	} catch {
		return null;
	}
}
function hr() {
	return window.location.pathname + window.location.search;
}
function gr(e) {
	let t = fr(e) ? e : "/";
	window.location.href = t;
}
function _r(e) {
	try {
		let t = new URL(e, window.location.origin), n = window.location;
		return t.pathname === n.pathname && t.search === n.search;
	} catch {
		return !1;
	}
}
//#endregion
//#region src/components/AuthGuard/AuthGuard.tsx
function vr({ children: e, redirectTo: t, preserveReturnUrl: n = !0, fallback: r, loadingComponent: i, onDenied: a, navigate: o, requiredRoles: s, requiredPermissions: c, requireAllRoles: u }) {
	let { isAllowed: f, isLoading: p, isAuthenticated: m, denyReason: h, missingRoles: g, missingPermissions: _ } = hn({
		requiredRoles: s,
		requiredPermissions: c,
		requireAllRoles: u
	}), v = d(!1);
	return l(() => {
		if (!p) {
			if (f) {
				v.current = !1;
				return;
			}
			if (h !== "none" && a && a(h), h === "not_authenticated" && t) {
				if (v.current) return;
				let e = pr(t, n ? hr() : void 0);
				if (_r(e)) {
					console.warn("[AuthGuard] Redirect loop detected, skipping redirect");
					return;
				}
				v.current = !0, o ? o(e, { replace: !0 }) : gr(e);
			}
		}
	}, [
		p,
		f,
		m,
		h,
		t,
		n,
		a,
		o
	]), p ? i || /* @__PURE__ */ L(lr, {}) : f ? /* @__PURE__ */ L(I, { children: e }) : m && h !== "not_authenticated" ? r || /* @__PURE__ */ L(cr, {
		missingRoles: g,
		missingPermissions: _
	}) : t ? i || /* @__PURE__ */ L(lr, {}) : r || /* @__PURE__ */ L(cr, {});
}
//#endregion
//#region src/components/AuthGuard/ProtectedRoute.tsx
function yr({ children: e, element: t, ...n }) {
	let r = t || e;
	return /* @__PURE__ */ L(vr, {
		...n,
		children: r
	});
}
//#endregion
//#region src/components/UserMenu/UserAvatar.tsx
function br({ src: e, name: t, size: n = "md", radius: r = "xl", className: i }) {
	return /* @__PURE__ */ L(h, {
		src: e,
		name: t,
		alt: t,
		size: n,
		radius: r,
		color: "initials",
		className: i
	});
}
var xr = {
	userButton: "_userButton_1mcpb_5",
	userName: "_userName_1mcpb_28",
	chevron: "_chevron_1mcpb_32"
};
//#endregion
//#region src/components/UserMenu/UserMenu.tsx
function Sr({ showProfile: e = !0, showOrders: t = !1, showFinances: n = !1, profileHref: r = "/profile", ordersHref: i = "/orders", financesHref: a = "/finances", additionalItems: o = [], onLogout: c, confirmLogout: l = !1, logoutRedirect: u, avatarSrc: d, hideUserName: p = !1, children: m }) {
	let { t: h } = F("auth"), { user: g, logout: v, isLoading: y } = pn(), [b, S] = f(!1), [T, { open: E, close: D }] = be(!1), [O, j] = f(!1), ee = xe("(max-width: 768px)"), te = p || ee, N = s(() => {
		l ? E() : ne();
	}, [l, E]), ne = s(async () => {
		j(!0);
		try {
			let e = u || "/";
			window.location.href = e, await v(), Se.show({
				title: h("userMenu.logout_success_title"),
				message: h("userMenu.logout_success_message"),
				color: "blue",
				autoClose: 3e3
			}), c?.();
		} finally {
			j(!1), D();
		}
	}, [
		v,
		c,
		u,
		D,
		h
	]), re = s(() => {
		ne();
	}, [ne]);
	if (!g) return null;
	let ie = g.name || "", ae = [];
	e && ae.push({
		label: h("userMenu.profile"),
		icon: _e,
		href: r
	}), t && ae.push({
		label: h("userMenu.orders"),
		icon: ge,
		href: i
	}), n && ae.push({
		label: h("userMenu.finances"),
		icon: ve,
		href: a
	});
	let oe = [...ae, ...o], se = (e, t) => {
		let n = [];
		e.dividerBefore && n.push(/* @__PURE__ */ L(C.Divider, {}, `divider-before-${t}`));
		let r = e.icon, i = /* @__PURE__ */ L(C.Item, {
			leftSection: r ? /* @__PURE__ */ L(r, {
				size: 16,
				stroke: 1.5
			}) : void 0,
			onClick: e.onClick,
			component: e.href ? "a" : void 0,
			href: e.href,
			children: e.label
		}, `item-${t}`);
		return n.push(i), e.dividerAfter && n.push(/* @__PURE__ */ L(C.Divider, {}, `divider-after-${t}`)), n;
	};
	return /* @__PURE__ */ R(I, { children: [/* @__PURE__ */ R(C, {
		width: 220,
		position: "bottom-end",
		transitionProps: { transition: "pop-top-right" },
		opened: b,
		onChange: S,
		withinPortal: !0,
		children: [/* @__PURE__ */ L(C.Target, { children: /* @__PURE__ */ L(M, {
			className: xr.userButton,
			"data-opened": b || void 0,
			"aria-label": h("userMenu.menuLabel"),
			children: /* @__PURE__ */ R(x, {
				gap: "xs",
				wrap: "nowrap",
				children: [/* @__PURE__ */ L(br, {
					src: d,
					name: ie,
					size: "sm"
				}), !te && /* @__PURE__ */ R(I, { children: [/* @__PURE__ */ L(A, {
					size: "sm",
					fw: 500,
					className: xr.userName,
					lineClamp: 1,
					children: ie
				}), /* @__PURE__ */ L(le, {
					size: 14,
					stroke: 1.5,
					className: xr.chevron,
					"data-opened": b || void 0
				})] })]
			})
		}) }), /* @__PURE__ */ R(C.Dropdown, { children: [
			oe.map((e, t) => se(e, t)),
			oe.length > 0 && /* @__PURE__ */ L(C.Divider, {}),
			/* @__PURE__ */ L(C.Item, {
				color: "red",
				leftSection: /* @__PURE__ */ L(pe, {
					size: 16,
					stroke: 1.5
				}),
				onClick: N,
				disabled: y || O,
				children: h("userMenu.logout")
			}),
			m
		] })]
	}), /* @__PURE__ */ L(w, {
		opened: T,
		onClose: D,
		title: h("userMenu.logoutConfirmTitle"),
		centered: !0,
		size: "sm",
		children: /* @__PURE__ */ R(k, {
			gap: "md",
			children: [/* @__PURE__ */ L(A, {
				size: "sm",
				children: h("userMenu.logoutConfirmMessage")
			}), /* @__PURE__ */ R(x, {
				justify: "flex-end",
				gap: "sm",
				children: [/* @__PURE__ */ L(_, {
					variant: "default",
					onClick: D,
					disabled: O,
					children: h("userMenu.cancel")
				}), /* @__PURE__ */ L(_, {
					color: "red",
					onClick: re,
					loading: O,
					children: h("userMenu.logout")
				})]
			})]
		})
	})] });
}
//#endregion
//#region src/components/AuthProvider/AuthProvider.tsx
var Cr = o(null);
function wr() {
	let e = c(Cr);
	if (!e) throw Error("useAuthContext must be used within AuthProvider");
	return e;
}
function Tr({ children: e, apiBaseUrl: t, apiTimeout: n = 3e4, enableCrossTabSync: r = !0, refreshThreshold: i, maxRetries: a, retryBaseDelay: o, onRefreshError: s, onSessionExpired: c }) {
	let d = xn({
		refreshThreshold: i,
		maxRetries: a,
		retryBaseDelay: o,
		onRefreshError: s,
		onSessionExpired: c
	});
	u(() => {
		pt({
			baseUrl: t,
			timeout: n,
			getToken: () => q.getState().token
		}), ht(() => q.getState().token);
	}, [t, n]), l(() => {
		let e;
		return r && (e = Lt()), () => {
			e?.();
		};
	}, [r]);
	let f = {
		...d,
		isInitialized: !0
	};
	return /* @__PURE__ */ L(Cr.Provider, {
		value: f,
		children: e
	});
}
//#endregion
//#region src/utils/portalOAuthContext.ts
var Er = "teletienda.oauth.portal", Dr = 600 * 1e3;
function Or(e) {
	let t = {
		...e,
		savedAt: Date.now()
	};
	try {
		sessionStorage.setItem(Er, JSON.stringify(t));
	} catch {}
}
function kr() {
	try {
		sessionStorage.removeItem(Er);
	} catch {}
}
function Ar() {
	try {
		let e = sessionStorage.getItem(Er);
		if (sessionStorage.removeItem(Er), !e) return null;
		let t = JSON.parse(e);
		return typeof t?.domain != "string" || typeof t?.returnUrl != "string" || typeof t.savedAt != "number" || Date.now() - t.savedAt > Dr ? null : {
			domain: t.domain,
			returnUrl: t.returnUrl
		};
	} catch {
		return null;
	}
}
function jr(e) {
	return `/portal/login?${new URLSearchParams({
		domain: e.domain,
		returnUrl: e.returnUrl
	}).toString()}`;
}
//#endregion
//#region src/utils/oauthLinkResult.ts
var Mr = "teletienda.oauth.linkResult", Nr = 60 * 1e3;
function Pr(e) {
	let t = {
		result: e,
		savedAt: Date.now()
	};
	try {
		sessionStorage.setItem(Mr, JSON.stringify(t));
	} catch {}
}
function Fr() {
	try {
		let e = sessionStorage.getItem(Mr);
		if (sessionStorage.removeItem(Mr), !e) return null;
		let t = JSON.parse(e);
		if (typeof t?.savedAt != "number" || Date.now() - t.savedAt > Nr) return null;
		let n = t.result;
		return !n || typeof n != "object" || typeof n.status != "string" || typeof n.provider != "string" ? null : n;
	} catch {
		return null;
	}
}
//#endregion
//#region src/components/AuthCallbackPage/AuthCallbackPage.tsx
function Ir({ provider: e, onSuccess: t, onError: n, onCancel: r, defaultReturnUrl: i = "/", linkReturnUrl: a = "/profile", loginUrl: o = "/login" }) {
	let { t: s } = F("auth"), [c, u] = f(null), [h, g] = f(!1), [_, y] = f(!0), b = q((e) => e.login), x = d(!1);
	l(() => {
		x.current || (x.current = !0, C());
	}, []);
	async function C() {
		try {
			let n = new URLSearchParams(window.location.search), a = n.get("code"), o = n.get("state"), c = n.get("error"), l = n.get("error_description");
			if (c === "access_denied") {
				g(!0), r?.();
				return;
			}
			if (c) throw Error(s("oauth.errors.provider_denied", { error: l || c }));
			if (!a) throw Error(s("oauth.errors.missing_code"));
			let u;
			switch (e) {
				case "google": {
					if (!o) throw Error(s("oauth.errors.missing_state"));
					let e = await Zt(a, o);
					if (e.intent === "link") {
						w("google", e);
						return;
					}
					u = e;
					break;
				}
				case "telegram": {
					if (!o) throw Error(s("oauth.errors.missing_state"));
					let e = await tn(a, o);
					if (e.intent === "link") {
						w("telegram", e);
						return;
					}
					u = e;
					break;
				}
				case "facebook": throw Error(s("oauth.errors.facebook_no_redirect"));
				default: throw Error(s("oauth.errors.unknown_provider"));
			}
			let d = await X(u.accessToken), f = W({
				...d,
				user_guid: d.user_guid || u.user.guid,
				email: d.email || u.user.email || void 0
			});
			b(u.accessToken, u.refreshToken, u.expiresIn, f);
			let p = Ar(), m = u.returnUrl || (p ? jr(p) : null) || i;
			t?.(m);
		} catch (e) {
			if (T(e)) {
				t?.(a);
				return;
			}
			let r = In(e, s);
			u(r), n?.(e instanceof Error ? e : Error(r));
		} finally {
			y(!1);
		}
	}
	function w(e, n) {
		Pr({
			status: "linked",
			provider: e,
			alreadyLinked: n.alreadyLinked
		}), t?.(n.returnUrl || a);
	}
	function T(t) {
		let n = t;
		if (n?.status !== 409) return !1;
		let r = e, i = n.details?.merge_challenge;
		return n.code === "MERGE_AVAILABLE" && typeof i == "string" && i ? Pr({
			status: "merge_available",
			provider: r,
			challenge: i
		}) : Pr({
			status: "failed",
			provider: r,
			code: n.code ?? null
		}), !0;
	}
	return _ ? /* @__PURE__ */ L(v, {
		h: "100vh",
		children: /* @__PURE__ */ R(k, {
			align: "center",
			gap: "md",
			children: [/* @__PURE__ */ L(S, { size: "lg" }), /* @__PURE__ */ L(A, {
				c: "dimmed",
				children: s("oauth.processing")
			})]
		})
	}) : h ? /* @__PURE__ */ L(v, {
		h: "100vh",
		children: /* @__PURE__ */ L(p, {
			icon: /* @__PURE__ */ L(de, { size: 16 }),
			title: s("oauth.cancelled_title"),
			color: "gray",
			variant: "light",
			maw: 400,
			children: s("oauth.cancelled")
		})
	}) : c ? /* @__PURE__ */ L(v, {
		h: "100vh",
		children: /* @__PURE__ */ L(p, {
			icon: /* @__PURE__ */ L(ie, { size: 16 }),
			title: s("oauth.error_title"),
			color: "red",
			variant: "light",
			maw: 400,
			children: /* @__PURE__ */ R(k, {
				gap: "xs",
				align: "flex-start",
				children: [/* @__PURE__ */ L(A, {
					size: "sm",
					children: c
				}), /* @__PURE__ */ L(m, {
					href: o,
					size: "sm",
					children: s("oauth.back_to_login")
				})]
			})
		})
	}) : null;
}
//#endregion
//#region src/utils/token.ts
function Lr(e) {
	try {
		let t = e.split(".");
		if (t.length !== 3) return null;
		let n = t[1], r = atob(n.replace(/-/g, "+").replace(/_/g, "/"));
		return JSON.parse(r);
	} catch {
		return null;
	}
}
function Rr(e) {
	let t = Lr(e);
	return t?.exp ? /* @__PURE__ */ new Date(t.exp * 1e3) : null;
}
function zr(e, t = 0) {
	let n = Rr(e);
	if (!n) return !0;
	let r = t * 1e3;
	return Date.now() >= n.getTime() - r;
}
function Br(e) {
	return Lr(e)?.sub ?? null;
}
function Vr(e) {
	let t = Rr(e);
	if (!t) return 0;
	let n = t.getTime() - Date.now();
	return Math.max(0, Math.floor(n / 1e3));
}
var Hr = {
	login: {
		modal_title: "Iniciar sesión",
		page_title: "Iniciar sesión",
		page_subtitle: "Ingresa con tu cuenta",
		email_label: "Correo electrónico",
		email_placeholder: "tu@email.com",
		password_label: "Contraseña",
		password_placeholder: "Tu contraseña",
		submit: "Iniciar sesión",
		remember_me: "Recordarme",
		forgot_password: "¿Olvidaste tu contraseña?",
		no_account: "¿No tienes cuenta? Regístrate",
		error_title: "Error de autenticación",
		help_text: "¿Problemas para ingresar? Contacta al administrador.",
		success_title: "¡Bienvenido!",
		success_message: "Has iniciado sesión correctamente",
		or_with_email: "o con email",
		method_password: "Contraseña",
		method_code: "Código por email",
		send_code: "Enviar código de acceso",
		code: "Código de verificación",
		verify_and_sign_in: "Verificar e ingresar",
		resend_code: "Reenviar código",
		code_sent: "Código enviado a tu email",
		errors: {
			email_required: "El correo electrónico es requerido",
			email_invalid: "Correo electrónico inválido",
			password_required: "La contraseña es requerida",
			invalid_credentials: "Correo o contraseña incorrectos",
			account_locked: "Tu cuenta está bloqueada. Contacta al administrador.",
			account_disabled: "Tu cuenta está deshabilitada",
			email_not_verified: "Por favor verifica tu correo electrónico",
			generic: "Ocurrió un error. Intenta de nuevo.",
			code_invalid: "El código debe tener 6 dígitos",
			code_send_failed: "Error al enviar el código. Intenta de nuevo.",
			code_expired: "Código expirado. Solicita uno nuevo.",
			code_rate_limited: "Demasiados intentos. Espera 5 minutos.",
			code_invalid_value: "Código inválido. {{remaining}} intentos restantes."
		}
	},
	register: {
		modal_title: "Crear cuenta",
		page_title: "Registrarse",
		page_subtitle: "Crea tu cuenta",
		name_label: "Nombre completo",
		name_placeholder: "Juan Pérez",
		email_label: "Correo electrónico",
		email_placeholder: "tu@email.com",
		password_label: "Contraseña",
		password_placeholder: "Mínimo 8 caracteres",
		confirm_password_label: "Confirmar contraseña",
		confirm_password_placeholder: "Repite tu contraseña",
		terms_prefix: "Acepto los",
		terms_link: "Términos y Condiciones",
		terms_and: "y la",
		privacy_link: "Política de Privacidad",
		submit: "Crear cuenta",
		have_account: "¿Ya tienes cuenta? Inicia sesión",
		or_email: "o con email",
		error_title: "Error de registro",
		errors: {
			name_required: "El nombre es requerido",
			name_too_long: "El nombre es muy largo (máximo 100 caracteres)",
			email_required: "El correo electrónico es requerido",
			email_invalid: "Correo electrónico inválido",
			email_exists: "Ya existe una cuenta con este correo",
			password_min_length: "La contraseña debe tener al menos 8 caracteres",
			password_uppercase: "La contraseña debe contener al menos una mayúscula",
			password_lowercase: "La contraseña debe contener al menos una minúscula",
			password_number: "La contraseña debe contener al menos un número",
			confirm_password_required: "Confirma tu contraseña",
			passwords_mismatch: "Las contraseñas no coinciden",
			terms_required: "Debes aceptar los términos y condiciones",
			validation_error: "Error de validación. Revisa los campos.",
			rate_limited: "Demasiados intentos. Intenta más tarde.",
			generic: "Ocurrió un error. Intenta de nuevo."
		},
		verification: {
			title: "Verifica tu correo",
			message: "Hemos enviado un enlace de verificación a {{email}}. Por favor revisa tu bandeja de entrada.",
			resend_button: "Reenviar correo de verificación",
			resend_sent: "Correo enviado",
			resend_success: "Hemos reenviado el correo de verificación.",
			resend_error: "Error al reenviar. Intenta de nuevo.",
			back_to_login: "Volver a iniciar sesión"
		}
	},
	password: {
		strength: {
			label: "Fortaleza de contraseña",
			weak: "Débil",
			fair: "Regular",
			good: "Buena",
			strong: "Fuerte"
		},
		requirements: {
			length: "Mínimo 8 caracteres",
			uppercase: "Al menos una letra mayúscula",
			lowercase: "Al menos una letra minúscula",
			number: "Al menos un número"
		}
	},
	guard: {
		loading: "Verificando autenticación...",
		unauthorized_title: "Acceso Denegado",
		unauthorized_message: "No tienes permiso para acceder a esta página.",
		go_back: "Volver",
		go_home: "Ir al Inicio"
	},
	userMenu: {
		menuLabel: "Menú de usuario",
		profile: "Mi Perfil",
		orders: "Mis Pedidos",
		finances: "Mis Finanzas",
		logout: "Cerrar sesión",
		logoutConfirmTitle: "Cerrar sesión",
		logoutConfirmMessage: "¿Estás seguro de que quieres cerrar sesión?",
		cancel: "Cancelar",
		logout_success_title: "Sesión cerrada",
		logout_success_message: "Has cerrado sesión correctamente"
	},
	portal: {
		title: "Iniciar sesión en TeleTienda",
		register_title: "Crear cuenta TeleTienda",
		continue_to: "para continuar a {{domain}}",
		redirecting: "Redirigiendo a {{domain}}...",
		code_error: "Error al completar la autenticación. Por favor, inténtalo de nuevo."
	},
	oauth: {
		divider: "o continuar con",
		processing: "Iniciando sesión...",
		error_title: "Error de autenticación",
		google: {
			button: "Iniciar sesión con Google",
			signup_button: "Registrarse con Google"
		},
		facebook: {
			button: "Iniciar sesión con Facebook",
			signup_button: "Registrarse con Facebook"
		},
		telegram: {
			button: "Iniciar sesión con Telegram",
			signup_button: "Registrarse con Telegram"
		},
		errors: {
			provider_denied: "Acceso denegado: {{error}}",
			unknown_provider: "Proveedor de autenticación desconocido",
			missing_code: "Código de autorización faltante",
			popup_blocked: "La ventana emergente fue bloqueada. Permita ventanas emergentes e intente de nuevo.",
			network: "Error de red. Verifique su conexión.",
			generic: "Error de autenticación. Por favor, intente de nuevo.",
			missing_state: "Falta el parámetro de estado en el enlace de retorno",
			malformed_link: "El enlace de retorno está dañado. Iniciá sesión de nuevo.",
			session_expired: "La sesión de inicio expiró. Por favor, intentá iniciar sesión de nuevo.",
			rate_limited: "Demasiados intentos. Esperá un momento y volvé a intentar.",
			service_unavailable: "El servicio de inicio de sesión no está disponible temporalmente. No es un problema con tu cuenta.",
			facebook_no_redirect: "Facebook no soporta flujo de redirección"
		},
		cancelled_title: "Inicio de sesión cancelado",
		cancelled: "Cancelaste el inicio de sesión. Podés intentarlo de nuevo cuando quieras.",
		back_to_login: "Volver al inicio de sesión"
	}
}, Ur = {
	login: {
		modal_title: "Sign in",
		page_title: "Sign in",
		page_subtitle: "Log in to your account",
		email_label: "Email",
		email_placeholder: "your@email.com",
		password_label: "Password",
		password_placeholder: "Your password",
		submit: "Sign in",
		remember_me: "Remember me",
		forgot_password: "Forgot password?",
		no_account: "Don't have an account? Sign up",
		error_title: "Authentication error",
		help_text: "Having trouble signing in? Contact the administrator.",
		success_title: "Welcome!",
		success_message: "You have signed in successfully",
		or_with_email: "or with email",
		method_password: "Password",
		method_code: "Email Code",
		send_code: "Send login code",
		code: "Verification code",
		verify_and_sign_in: "Verify & Sign in",
		resend_code: "Resend code",
		code_sent: "Code sent to your email",
		errors: {
			email_required: "Email is required",
			email_invalid: "Invalid email address",
			password_required: "Password is required",
			invalid_credentials: "Invalid email or password",
			account_locked: "Your account is locked. Contact the administrator.",
			account_disabled: "Your account is disabled",
			email_not_verified: "Please verify your email address",
			generic: "An error occurred. Please try again.",
			code_invalid: "Code must be 6 digits",
			code_send_failed: "Failed to send code. Please try again.",
			code_expired: "Code expired. Please request a new one.",
			code_rate_limited: "Too many attempts. Please wait 5 minutes.",
			code_invalid_value: "Invalid code. {{remaining}} attempts remaining."
		}
	},
	register: {
		modal_title: "Create account",
		page_title: "Sign up",
		page_subtitle: "Create your account",
		name_label: "Full name",
		name_placeholder: "John Doe",
		email_label: "Email",
		email_placeholder: "your@email.com",
		password_label: "Password",
		password_placeholder: "Minimum 8 characters",
		confirm_password_label: "Confirm password",
		confirm_password_placeholder: "Repeat your password",
		terms_prefix: "I accept the",
		terms_link: "Terms and Conditions",
		terms_and: "and the",
		privacy_link: "Privacy Policy",
		submit: "Create account",
		have_account: "Already have an account? Sign in",
		or_email: "or with email",
		error_title: "Registration error",
		errors: {
			name_required: "Name is required",
			name_too_long: "Name is too long (maximum 100 characters)",
			email_required: "Email is required",
			email_invalid: "Invalid email address",
			email_exists: "An account with this email already exists",
			password_min_length: "Password must be at least 8 characters",
			password_uppercase: "Password must contain at least one uppercase letter",
			password_lowercase: "Password must contain at least one lowercase letter",
			password_number: "Password must contain at least one number",
			confirm_password_required: "Please confirm your password",
			passwords_mismatch: "Passwords do not match",
			terms_required: "You must accept the terms and conditions",
			validation_error: "Validation error. Please check the fields.",
			rate_limited: "Too many attempts. Please try again later.",
			generic: "An error occurred. Please try again."
		},
		verification: {
			title: "Verify your email",
			message: "We've sent a verification link to {{email}}. Please check your inbox.",
			resend_button: "Resend verification email",
			resend_sent: "Email sent",
			resend_success: "We've resent the verification email.",
			resend_error: "Failed to resend. Please try again.",
			back_to_login: "Back to sign in"
		}
	},
	password: {
		strength: {
			label: "Password strength",
			weak: "Weak",
			fair: "Fair",
			good: "Good",
			strong: "Strong"
		},
		requirements: {
			length: "Minimum 8 characters",
			uppercase: "At least one uppercase letter",
			lowercase: "At least one lowercase letter",
			number: "At least one number"
		}
	},
	guard: {
		loading: "Checking authentication...",
		unauthorized_title: "Access Denied",
		unauthorized_message: "You don't have permission to access this page.",
		go_back: "Go Back",
		go_home: "Go Home"
	},
	userMenu: {
		menuLabel: "User menu",
		profile: "My Profile",
		orders: "My Orders",
		finances: "My Finances",
		logout: "Log out",
		logoutConfirmTitle: "Log out",
		logoutConfirmMessage: "Are you sure you want to log out?",
		cancel: "Cancel",
		logout_success_title: "Logged out",
		logout_success_message: "You have logged out successfully"
	},
	portal: {
		title: "Sign in to TeleTienda",
		register_title: "Create TeleTienda Account",
		continue_to: "to continue to {{domain}}",
		redirecting: "Redirecting to {{domain}}...",
		code_error: "Failed to complete authentication. Please try again."
	},
	oauth: {
		divider: "or continue with",
		processing: "Signing you in...",
		error_title: "Authentication Failed",
		google: {
			button: "Sign in with Google",
			signup_button: "Sign up with Google"
		},
		facebook: {
			button: "Sign in with Facebook",
			signup_button: "Sign up with Facebook"
		},
		telegram: {
			button: "Log in with Telegram",
			signup_button: "Sign up with Telegram"
		},
		errors: {
			provider_denied: "Access was denied by {{error}}",
			unknown_provider: "Unknown authentication provider",
			missing_code: "Missing authorization code",
			popup_blocked: "Popup was blocked. Please allow popups and try again.",
			network: "Network error. Please check your connection.",
			generic: "Authentication failed. Please try again.",
			missing_state: "The return link is missing its state parameter",
			malformed_link: "The return link is damaged. Please sign in again.",
			session_expired: "Your sign-in session expired. Please try signing in again.",
			rate_limited: "Too many attempts. Please wait a moment and try again.",
			service_unavailable: "The sign-in service is temporarily unavailable. This is not a problem with your account.",
			facebook_no_redirect: "Facebook does not support the redirect flow"
		},
		cancelled_title: "Sign-in cancelled",
		cancelled: "You cancelled the sign-in. You can try again whenever you like.",
		back_to_login: "Back to sign in"
	}
}, Wr = {
	login: {
		modal_title: "Вход",
		page_title: "Вход в систему",
		page_subtitle: "Войдите в свой аккаунт",
		email_label: "Электронная почта",
		email_placeholder: "ваш@email.com",
		password_label: "Пароль",
		password_placeholder: "Ваш пароль",
		submit: "Войти",
		remember_me: "Запомнить меня",
		forgot_password: "Забыли пароль?",
		no_account: "Нет аккаунта? Зарегистрируйтесь",
		error_title: "Ошибка авторизации",
		help_text: "Проблемы со входом? Свяжитесь с администратором.",
		success_title: "Добро пожаловать!",
		success_message: "Вы успешно вошли в систему",
		or_with_email: "или по email",
		method_password: "Пароль",
		method_code: "Код на email",
		send_code: "Отправить код входа",
		code: "Код подтверждения",
		verify_and_sign_in: "Подтвердить и войти",
		resend_code: "Отправить код ещё раз",
		code_sent: "Код отправлен на ваш email",
		errors: {
			email_required: "Email обязателен",
			email_invalid: "Неверный формат email",
			password_required: "Пароль обязателен",
			invalid_credentials: "Неверный email или пароль",
			account_locked: "Ваш аккаунт заблокирован. Свяжитесь с администратором.",
			account_disabled: "Ваш аккаунт отключен",
			email_not_verified: "Пожалуйста, подтвердите ваш email",
			generic: "Произошла ошибка. Попробуйте снова.",
			code_invalid: "Код должен содержать 6 цифр",
			code_send_failed: "Не удалось отправить код. Попробуйте снова.",
			code_expired: "Код истёк. Запросите новый.",
			code_rate_limited: "Слишком много попыток. Подождите 5 минут.",
			code_invalid_value: "Неверный код. Осталось попыток: {{remaining}}."
		}
	},
	register: {
		modal_title: "Создать аккаунт",
		page_title: "Регистрация",
		page_subtitle: "Создайте свой аккаунт",
		name_label: "Полное имя",
		name_placeholder: "Иван Иванов",
		email_label: "Электронная почта",
		email_placeholder: "ваш@email.com",
		password_label: "Пароль",
		password_placeholder: "Минимум 8 символов",
		confirm_password_label: "Подтвердите пароль",
		confirm_password_placeholder: "Повторите пароль",
		terms_prefix: "Я принимаю",
		terms_link: "Условия использования",
		terms_and: "и",
		privacy_link: "Политику конфиденциальности",
		submit: "Создать аккаунт",
		have_account: "Уже есть аккаунт? Войти",
		or_email: "или по email",
		error_title: "Ошибка регистрации",
		errors: {
			name_required: "Имя обязательно",
			name_too_long: "Имя слишком длинное (максимум 100 символов)",
			email_required: "Email обязателен",
			email_invalid: "Неверный формат email",
			email_exists: "Аккаунт с таким email уже существует",
			password_min_length: "Пароль должен содержать минимум 8 символов",
			password_uppercase: "Пароль должен содержать хотя бы одну заглавную букву",
			password_lowercase: "Пароль должен содержать хотя бы одну строчную букву",
			password_number: "Пароль должен содержать хотя бы одну цифру",
			confirm_password_required: "Подтвердите пароль",
			passwords_mismatch: "Пароли не совпадают",
			terms_required: "Вы должны принять условия использования",
			validation_error: "Ошибка валидации. Проверьте поля.",
			rate_limited: "Слишком много попыток. Попробуйте позже.",
			generic: "Произошла ошибка. Попробуйте снова."
		},
		verification: {
			title: "Подтвердите email",
			message: "Мы отправили ссылку для подтверждения на {{email}}. Проверьте вашу почту.",
			resend_button: "Отправить письмо повторно",
			resend_sent: "Письмо отправлено",
			resend_success: "Мы повторно отправили письмо для подтверждения.",
			resend_error: "Не удалось отправить. Попробуйте снова.",
			back_to_login: "Вернуться к входу"
		}
	},
	password: {
		strength: {
			label: "Надежность пароля",
			weak: "Слабый",
			fair: "Средний",
			good: "Хороший",
			strong: "Надежный"
		},
		requirements: {
			length: "Минимум 8 символов",
			uppercase: "Хотя бы одна заглавная буква",
			lowercase: "Хотя бы одна строчная буква",
			number: "Хотя бы одна цифра"
		}
	},
	guard: {
		loading: "Проверка аутентификации...",
		unauthorized_title: "Доступ Запрещен",
		unauthorized_message: "У вас нет прав для доступа к этой странице.",
		go_back: "Назад",
		go_home: "На Главную"
	},
	userMenu: {
		menuLabel: "Меню пользователя",
		profile: "Мой Профиль",
		orders: "Мои Заказы",
		finances: "Мои Финансы",
		logout: "Выйти",
		logoutConfirmTitle: "Выход из системы",
		logoutConfirmMessage: "Вы уверены, что хотите выйти?",
		cancel: "Отмена",
		logout_success_title: "Вы вышли",
		logout_success_message: "Вы успешно вышли из системы"
	},
	portal: {
		title: "Вход в TeleTienda",
		register_title: "Создать аккаунт TeleTienda",
		continue_to: "для продолжения на {{domain}}",
		redirecting: "Перенаправление на {{domain}}...",
		code_error: "Не удалось завершить авторизацию. Пожалуйста, попробуйте снова."
	},
	oauth: {
		divider: "или продолжить через",
		processing: "Выполняется вход...",
		error_title: "Ошибка аутентификации",
		google: {
			button: "Войти через Google",
			signup_button: "Зарегистрироваться через Google"
		},
		facebook: {
			button: "Войти через Facebook",
			signup_button: "Зарегистрироваться через Facebook"
		},
		telegram: {
			button: "Войти через Telegram",
			signup_button: "Зарегистрироваться через Telegram"
		},
		errors: {
			provider_denied: "Доступ запрещен: {{error}}",
			unknown_provider: "Неизвестный провайдер аутентификации",
			missing_code: "Отсутствует код авторизации",
			popup_blocked: "Всплывающее окно заблокировано. Разрешите всплывающие окна и попробуйте снова.",
			network: "Ошибка сети. Проверьте подключение.",
			generic: "Ошибка аутентификации. Попробуйте снова.",
			missing_state: "В ссылке возврата отсутствует параметр state",
			malformed_link: "Ссылка возврата повреждена. Войдите заново.",
			session_expired: "Сессия входа истекла. Пожалуйста, попробуйте войти ещё раз.",
			rate_limited: "Слишком много попыток. Подождите немного и попробуйте снова.",
			service_unavailable: "Сервис входа временно недоступен. Это не проблема с вашим аккаунтом.",
			facebook_no_redirect: "Facebook не поддерживает redirect-флоу"
		},
		cancelled_title: "Вход отменён",
		cancelled: "Вы отменили вход. Можно попробовать снова в любой момент.",
		back_to_login: "Вернуться к входу"
	}
}, Gr = {
	login: {
		modal_title: "Entrar",
		page_title: "Entrar",
		page_subtitle: "Acesse sua conta",
		email_label: "E-mail",
		email_placeholder: "seu@email.com",
		password_label: "Senha",
		password_placeholder: "Sua senha",
		submit: "Entrar",
		remember_me: "Lembrar-me",
		forgot_password: "Esqueceu a senha?",
		no_account: "Não tem conta? Cadastre-se",
		error_title: "Erro de autenticação",
		help_text: "Problemas para entrar? Entre em contato com o administrador.",
		success_title: "Bem-vindo!",
		success_message: "Você entrou com sucesso",
		or_with_email: "ou com e-mail",
		method_password: "Senha",
		method_code: "Código por e-mail",
		send_code: "Enviar código de acesso",
		code: "Código de verificação",
		verify_and_sign_in: "Verificar e entrar",
		resend_code: "Reenviar código",
		code_sent: "Código enviado para seu e-mail",
		errors: {
			email_required: "O e-mail é obrigatório",
			email_invalid: "E-mail inválido",
			password_required: "A senha é obrigatória",
			invalid_credentials: "E-mail ou senha incorretos",
			account_locked: "Sua conta está bloqueada. Entre em contato com o administrador.",
			account_disabled: "Sua conta está desativada",
			email_not_verified: "Por favor, verifique seu e-mail",
			generic: "Ocorreu um erro. Tente novamente.",
			code_invalid: "O código deve ter 6 dígitos",
			code_send_failed: "Erro ao enviar o código. Tente novamente.",
			code_expired: "Código expirado. Solicite um novo.",
			code_rate_limited: "Muitas tentativas. Aguarde 5 minutos.",
			code_invalid_value: "Código inválido. {{remaining}} tentativas restantes."
		}
	},
	register: {
		modal_title: "Criar conta",
		page_title: "Cadastrar",
		page_subtitle: "Crie sua conta",
		name_label: "Nome completo",
		name_placeholder: "João Silva",
		email_label: "E-mail",
		email_placeholder: "seu@email.com",
		password_label: "Senha",
		password_placeholder: "Mínimo 8 caracteres",
		confirm_password_label: "Confirmar senha",
		confirm_password_placeholder: "Repita sua senha",
		terms_prefix: "Eu aceito os",
		terms_link: "Termos e Condições",
		terms_and: "e a",
		privacy_link: "Política de Privacidade",
		submit: "Criar conta",
		have_account: "Já tem uma conta? Entrar",
		or_email: "ou com e-mail",
		error_title: "Erro de cadastro",
		errors: {
			name_required: "O nome é obrigatório",
			name_too_long: "O nome é muito longo (máximo 100 caracteres)",
			email_required: "O e-mail é obrigatório",
			email_invalid: "E-mail inválido",
			email_exists: "Já existe uma conta com este e-mail",
			password_min_length: "A senha deve ter pelo menos 8 caracteres",
			password_uppercase: "A senha deve conter pelo menos uma letra maiúscula",
			password_lowercase: "A senha deve conter pelo menos uma letra minúscula",
			password_number: "A senha deve conter pelo menos um número",
			confirm_password_required: "Por favor, confirme sua senha",
			passwords_mismatch: "As senhas não coincidem",
			terms_required: "Você deve aceitar os termos e condições",
			validation_error: "Erro de validação. Verifique os campos.",
			rate_limited: "Muitas tentativas. Tente novamente mais tarde.",
			generic: "Ocorreu um erro. Tente novamente."
		},
		verification: {
			title: "Verifique seu e-mail",
			message: "Enviamos um link de verificação para {{email}}. Por favor, verifique sua caixa de entrada.",
			resend_button: "Reenviar e-mail de verificação",
			resend_sent: "E-mail enviado",
			resend_success: "Reenviamos o e-mail de verificação.",
			resend_error: "Falha ao reenviar. Tente novamente.",
			back_to_login: "Voltar para entrar"
		}
	},
	password: {
		strength: {
			label: "Força da senha",
			weak: "Fraca",
			fair: "Regular",
			good: "Boa",
			strong: "Forte"
		},
		requirements: {
			length: "Mínimo 8 caracteres",
			uppercase: "Pelo menos uma letra maiúscula",
			lowercase: "Pelo menos uma letra minúscula",
			number: "Pelo menos um número"
		}
	},
	guard: {
		loading: "Verificando autenticação...",
		unauthorized_title: "Acesso Negado",
		unauthorized_message: "Você não tem permissão para acessar esta página.",
		go_back: "Voltar",
		go_home: "Ir para Início"
	},
	userMenu: {
		menuLabel: "Menu do usuário",
		profile: "Meu Perfil",
		orders: "Meus Pedidos",
		finances: "Minhas Finanças",
		logout: "Sair",
		logoutConfirmTitle: "Sair",
		logoutConfirmMessage: "Tem certeza de que deseja sair?",
		cancel: "Cancelar",
		logout_success_title: "Sessão encerrada",
		logout_success_message: "Você saiu com sucesso"
	},
	portal: {
		title: "Entrar na TeleTienda",
		register_title: "Criar conta TeleTienda",
		continue_to: "para continuar em {{domain}}",
		redirecting: "Redirecionando para {{domain}}...",
		code_error: "Falha ao completar a autenticação. Por favor, tente novamente."
	},
	oauth: {
		divider: "ou continuar com",
		processing: "Entrando...",
		error_title: "Falha na autenticação",
		google: {
			button: "Entrar com Google",
			signup_button: "Cadastrar com Google"
		},
		facebook: {
			button: "Entrar com Facebook",
			signup_button: "Cadastrar com Facebook"
		},
		telegram: {
			button: "Entrar com Telegram",
			signup_button: "Cadastrar com Telegram"
		},
		errors: {
			provider_denied: "Acesso negado: {{error}}",
			unknown_provider: "Provedor de autenticação desconhecido",
			missing_code: "Código de autorização ausente",
			popup_blocked: "A janela pop-up foi bloqueada. Permita pop-ups e tente novamente.",
			network: "Erro de rede. Verifique sua conexão.",
			generic: "Falha na autenticação. Tente novamente.",
			missing_state: "Falta o parâmetro de estado no link de retorno",
			malformed_link: "O link de retorno está danificado. Faça login novamente.",
			session_expired: "A sessão de login expirou. Por favor, tente entrar novamente.",
			rate_limited: "Muitas tentativas. Aguarde um momento e tente novamente.",
			service_unavailable: "O serviço de login está temporariamente indisponível. Não é um problema com sua conta.",
			facebook_no_redirect: "O Facebook não suporta o fluxo de redirecionamento"
		},
		cancelled_title: "Login cancelado",
		cancelled: "Você cancelou o login. Pode tentar novamente quando quiser.",
		back_to_login: "Voltar ao login"
	}
}, Kr = [
	"es",
	"en",
	"ru",
	"pt"
], qr = "es", Jr = {
	es: { auth: Hr },
	en: { auth: Ur },
	ru: { auth: Wr },
	pt: { auth: Gr }
};
function Yr(e) {
	return Jr[e];
}
function Xr(e) {
	for (let t of Kr) e.addResourceBundle(t, "auth", Jr[t].auth, !0, !1);
}
//#endregion
export { Et as AUTH_STORAGE_NAME, Y as AuthApiError, Ir as AuthCallbackPage, vr as AuthGuard, Tr as AuthProvider, De as COOKIE_MAX_AGE, ot as COOKIE_MAX_SIZE, at as COOKIE_WARNING_THRESHOLD, Te as CROSS_SUBDOMAIN_SYNC_COOKIE, Ee as CROSS_SUBDOMAIN_SYNC_INTERVAL, qr as DEFAULT_LANGUAGE, zn as FacebookLoginButton, Rn as GoogleLoginButton, lr as LoadingFallback, Kn as LoginForm, Yn as LoginModal, Xn as LoginPage, Mr as OAUTH_LINK_RESULT_KEY, e as PLATFORM_ADMIN_ROLES, Er as PORTAL_OAUTH_CONTEXT_KEY, Oe as PRODUCTION_DOMAIN, nr as PasswordStrengthIndicator, yr as ProtectedRoute, ur as RETURN_URL_PARAM, ir as RegisterForm, or as RegisterModal, it as SLIM_AUTH_COOKIE_NAME, Ce as STORAGE_KEY, Kr as SUPPORTED_LANGUAGES, we as SYNC_CHANNEL_NAME, Un as SocialLoginButtons, Hn as TelegramLoginButton, cr as UnauthorizedFallback, br as UserAvatar, Sr as UserMenu, ar as VerificationSuccess, Xr as addAuthTranslations, ze as areCookiesEnabled, fn as authFetch, Jr as authTranslations, tt as broadcastCrossSubdomainLogin, nt as broadcastCrossSubdomainLogout, rt as broadcastCrossSubdomainTokenRefresh, qe as broadcastLogin, Je as broadcastLogout, Ye as broadcastTokenRefresh, pr as buildRedirectUrl, Qn as calculatePasswordStrength, Zn as checkPasswordRequirements, gt as checkStorageHealth, J as clearAuthStorage, kr as clearPortalOAuthContext, pt as configureAuthApi, un as configureHttpClient, Fr as consumeOAuthLinkResult, Ar as consumePortalOAuthContext, At as createAuthStoreSlice, sn as createAuthenticatedClient, Tt as createZustandStorage, Lr as decodeToken, Re as deleteCookie, V as deleteSlimCookie, In as describeOAuthError, Qt as facebookOAuthCallbackApi, X as fetchUserProfileApi, U as getApiClient, mt as getApiConfig, G as getAuthStorage, Yr as getAuthTranslations, Ie as getCookie, Ve as getCookieJSON, lt as getCookieSizeInfo, Qe as getCrossSubdomainSync, We as getCrossTabSync, hr as getCurrentPath, dn as getHttpClient, yn as getRefreshPromise, mr as getReturnUrl, B as getSlimCookie, z as getStorageConfig, Bt as getStorageHealth, $n as getStrengthColor, er as getStrengthLabel, Rr as getTokenExpiration, Vr as getTokenTTL, Br as getUserGuidFromToken, Jt as googleOAuthCallbackApi, Zt as googleOidcCallbackApi, bt as hasFullUserData, yt as hydrateFromApi, Lt as initAuthSync, xt as isHydrationNeeded, _t as isPrivateBrowsing, _r as isRedirectLoop, st as isSlimAuthData, zt as isTokenExpired, zr as isTokenExpiredFromString, fr as isValidReturnUrl, Ht as loginApi, qt as loginByCodeApi, Wn as loginSchema, Gt as logoutApi, Rt as needsTokenRefresh, Ke as onAuthSync, et as onCrossSubdomainSync, Fe as parseCookies, gr as performRedirect, jr as portalReturnPath, Wt as refreshTokenApi, Ut as registerApi, rr as registerSchema, Kt as requestLoginCodeApi, wt as resetAuthStorage, $e as resetCrossSubdomainSync, Ge as resetCrossTabSync, rn as resetHttpClientState, bn as resetRefreshPromise, Pe as resetStorageConfig, It as retryInitialHydration, Pr as saveOAuthLinkResult, Or as savePortalOAuthContext, Le as setCookie, Be as setCookieJSON, ut as setSlimCookie, Ot as setStorageAdapter, Ne as setStorageConfig, ht as setTokenGetter, Xt as startGoogleLinkOidcApi, Yt as startGoogleOidcApi, en as startTelegramLinkOidcApi, $t as startTelegramOidcApi, tn as telegramOidcCallbackApi, W as transformApiUser, pn as useAuth, wr as useAuthContext, hn as useAuthGuard, q as useAuthStore, Sn as useFacebookAuth, mn as useHasHydrated, xn as useTokenRefresh };

//# sourceMappingURL=index.es.js.map